export const ru = {
  phoneInput: {
    label: 'Телефон',
    favorites: 'Избранные',
    changeCountry: 'Сменить страну',
    search: {
      placeholder: 'Поиск страны (название, код)',
      noResults: 'Совпадений нет',
    },
  },
  auth: {
    login: {
      footer: 'Нет доступа? Обратитесь к администратору.',
      password: 'Пароль',
      pending: 'Входим…',
      submit: 'Войти',
      subtitle: 'Введите свои учётные данные',
      title: 'Вход в систему',
    },
    password: {
      copied: 'Скопировано',
      copy: 'Скопировать',
      copyFailed: 'Не удалось скопировать',
      generate: 'Сгенерировать пароль',
      revealToggle: 'Показать/скрыть',
    },
  },
  common: {
    a11y: {
      skipToContent: 'Перейти к содержимому',
    },
    actions: {
      activeOnly: 'Только активные',
      archive: 'Архивировать',
      back: 'Назад',
      cancel: 'Отмена',
      close: 'Закрыть',
      contact: 'Связаться',
      confirm: 'Подтвердить',
      create: 'Создать',
      delete: 'Удалить',
      deactivate: 'Деактивировать',
      edit: 'Редактировать',
      goHome: 'На главную',
      more: 'Ещё',
      next: 'Вперёд',
      reactivate: 'Реактивировать',
      reload: 'Перезагрузить',
      rename: 'Переименовать',
      resetPassword: 'Сбросить пароль',
      restore: 'Восстановить',
      retry: 'Повторить',
      save: 'Сохранить',
      select: 'Выбрать',
      showArchive: 'Показать архив',
      uploadFile: 'Загрузить файл',
    },
    confirm: {
      title: 'Подтвердите',
    },
    filters: {
      allPrefix: 'Все: {{label}}',
      rangeMax: 'до',
      rangeMin: 'от',
    },
    fields: {
      optional: 'Опционально',
      reasonPlaceholder: 'Причина…',
    },
    locales: {
      en: 'English',
      ru: 'Русский',
      zhHans: '简体中文',
    },
    pagination: {
      pageOfTotal: 'Стр. {{page}} из {{pages}} · всего {{total}}',
    },
    dataTable: {
      sortBy: 'Сортировка',
      sortDirection: {
        asc: 'По возрастанию',
        desc: 'По убыванию',
      },
    },
    combobox: {
      noResults: 'Ничего не найдено',
    },
    states: {
      emptyTitle: 'Пусто',
      errorText: 'Не удалось загрузить данные.',
      errorTitle: 'Ошибка',
      forbiddenText: 'У вас нет прав для просмотра этой страницы.',
      forbiddenTitle: 'Нет доступа',
      loadError: 'Не удалось загрузить',
      loading: 'Загрузка…',
      minimumReason: 'Минимум 3 символа',
      restoringSession: 'Восстанавливаем сессию…',
    },
    status: {
      active: 'Активен',
      activeFeminine: 'Активна',
      archive: 'Архив',
      archived: 'Архивная',
      closed: 'Закрыто',
      draft: 'Черновик',
      inWork: 'В работе',
      inactive: 'Неактивен',
      passwordResetRequired: 'Требуется смена пароля',
      processed: 'Обработано',
      return: 'Возврат',
      system: 'Системная',
    },
    units: {
      byte: 'Б',
      cubicMeterShort: 'м³',
      dayShort: 'дн',
      hourShort: 'ч',
      kilogramShort: 'кг',
      kilobyte: 'КБ',
      megabyte: 'МБ',
      minuteShort: 'мин',
    },
    unsavedChanges: {
      title: 'Несохранённые изменения',
      body: 'Есть несохранённые изменения. Продолжить редактирование или закрыть без сохранения?',
      continueEditing: 'Продолжить редактирование',
      closeWithoutSaving: 'Закрыть без сохранения',
    },
  },
  shell: {
    appError: {
      text: 'Произошла непредвиденная ошибка. Попробуйте перезагрузить страницу.',
      title: 'Что-то пошло не так',
    },
    language: {
      label: 'Язык',
    },
    moduleError: {
      text: 'Не удалось отобразить эту страницу.',
      title: 'Ошибка модуля',
    },
    nav: {
      groups: {
        admin: 'Администрирование',
        crm: 'CRM',
        dashboards: 'Дашборды',
        finance: 'Финансы',
        logistics: 'Логистика',
        refs: 'Справочники',
        work: 'Работа',
      },
      items: {
        agent: 'Агент',
        myDashboards: 'Мои дашборды',
        arrivalCities: 'Города прибытия',
        audit: 'Журнал аудита',
        calls: 'Звонковой центр',
        cargo: 'Грузы',
        cargoProblems: 'Грузы: проблемы',
        carriers: 'Перевозчики',
        chinaRates: 'Ставки Китай',
        chinaRequestsDashboard: 'Заявки Китай',
        clients: 'Клиенты',
        commercialProposals: 'КП',
        logisticsCalculations: 'ТТН',
        crmIntakeAdmin: 'Колл-центр и дежурство',
        deals: 'Сделки',
        depts: 'Отделы',
        leads: 'Лиды',
        payments: 'Заявки на оплату',
        prices: 'Прайсы',
        queues: 'Очереди',
        revenue: 'Выручка',
        roles: 'Роли',
        russiaCarriers: 'Перевозчики РФ',
        russiaRates: 'Ставки Россия',
        sla: 'SLA Контроль',
        sources: 'Источники',
        stages: 'Этапы',
        tasks: 'Задачи',
        transportTypes: 'Вид транспорта',
        roadOptions: 'Дороги',
        packagingOptions: 'Упаковка',
        users: 'Пользователи',
        warehouses: 'Склады',
        warehousesChina: 'На складе в Китае',
      },
    },
    notFound: {
      text: 'Страница не существует.',
      title: 'Не найдено',
    },
    placeholder: {
      text: 'Эта страница появится в следующей фазе миграции.',
      title: 'Скоро',
    },
    profile: {
      changePassword: 'Сменить пароль…',
      logout: 'Выйти',
      menu: 'Меню профиля',
      profile: 'Профиль',
      settings: 'Настройки',
    },
    sidebar: {
      collapse: 'Свернуть',
      collapseMenu: 'Свернуть меню',
      expand: 'Развернуть',
      expandMenu: 'Развернуть меню',
    },
    topbar: {
      menu: 'Меню',
      onShift: {
        label: 'На смене',
        ariaOn: 'Сейчас на смене — нажмите, чтобы выйти со смены',
        ariaOff: 'Не на смене — нажмите, чтобы заступить на смену',
      },
    },
    bell: {
      button: 'Уведомления',
      loading: 'Загрузка…',
      loadError: 'Не удалось загрузить уведомления',
      empty: 'Нет уведомлений',
      unreadHeader: 'Непрочитанные',
      recentHeader: 'Недавние',
      unreadDescription: {
        chat: '{{count}} новых сообщений в чате',
        rate: '{{count}} новых ответов перевозчиков',
        rejection: '{{count}} отказов перевозчиков',
        insurance: '{{count}} событий по страховке',
        responsibleStatus: 'Изменился ответственный',
        leadCallback: 'Запросы клиента на обратный звонок: {{count}}',
        cargoProblem: 'События по проблеме груза: {{count}}',
      },
      recentDescription: {
        chat: 'Чат',
        rate: 'Ответы перевозчиков',
        rejection: 'Отказы перевозчиков',
        insurance: 'Страховка',
        responsibleStatus: 'Ответственный',
        leadCallback: 'Клиент запросил обратный звонок',
        cargoProblem: 'Проблема груза',
      },
    },
    messages: { button: 'Сообщения' },
    notificationsRow: {
      aria: {
        dot: 'Есть непрочитанные уведомления',
        count_one: '{{count}} непрочитанное уведомление',
        count_few: '{{count}} непрочитанных уведомления',
        count_many: '{{count}} непрочитанных уведомлений',
        count_other: '{{count}} непрочитанных уведомлений',
        countCapped: '{{count}}+ непрочитанных уведомлений',
      },
    },
    workspaceTab: {
      aria: {
        notifications: {
          count_one: '{{count}} непрочитанное уведомление',
          count_few: '{{count}} непрочитанных уведомления',
          count_many: '{{count}} непрочитанных уведомлений',
          count_other: '{{count}} непрочитанных уведомлений',
          countCapped: '{{count}}+ непрочитанных уведомлений',
        },
      },
    },
  },
  settings: {
    title: 'Настройки',
    theme: {
      heading: 'Тема',
      light: 'Светлая',
      dark: 'Тёмная',
    },
    language: {
      heading: 'Язык',
    },
    notifications: {
      heading: 'Уведомления',
      loading: 'Загрузка…',
      loadError: 'Не удалось загрузить настройки уведомлений',
      previewButton: 'Прослушать',
      previewAriaLabel: 'Прослушать звук',
      previewFailed: 'Не удалось воспроизвести звук',
      soundOption: 'Звук {{index}}',
      soundSelectLabel: 'Звук уведомления',
      groups: {
        chat: 'Сообщения в чате',
        rates: 'Ставки, отказы, страховки',
        responsibleStatus: 'Смена ответственного',
      },
    },
  },
  profile: {
    title: 'Профиль',
    sections: {
      view: 'Личные данные',
      edit: 'Редактировать',
    },
    fields: {
      name: 'Имя',
      email: 'Email',
      phone: 'Телефон',
      role: 'Роль',
      department: 'Отдел',
      createdAt: 'Зарегистрирован',
    },
    actions: {
      save: 'Сохранить',
      changePassword: 'Сменить пароль',
    },
    toasts: {
      saved: 'Профиль обновлён',
    },
    errors: {
      nameRequired: 'Введите имя',
      nameTooLong: 'Имя слишком длинное (максимум 200 символов)',
      invalidPhone: 'Введите номер в международном формате, например +79991234567',
    },
    placeholders: {
      missing: '—',
    },
  },
  errors: {
    auth: {
      invalidCredentials: 'Неверный email или пароль',
      refreshInvalid: 'Сессия истекла. Войдите заново',
      refreshReused: 'Обнаружена подозрительная активность. Войдите заново',
      tokenInvalid: 'Сессия истекла. Войдите заново',
      unauthorized: 'Сессия истекла. Войдите заново',
      wrongCurrentPassword: 'Текущий пароль неверен',
    },
    domain: {
      actorHasOpenAssignment:
        'У пользователя есть открытые заявки. Сначала переназначьте их на другого логиста',
      cannotModifySelf: 'Нельзя редактировать или сбрасывать пароль себе',
      conflict: 'Конфликт данных. Обновите страницу',
      forbidden: 'Недостаточно прав',
      gateFailed: 'Условия для действия не выполнены',
      invalidTransition: 'Невозможное действие для текущего статуса',
      noLogistAvailable: 'Нет логистов на смене. Дождитесь, пока кто-то выйдет на смену',
      notFound: 'Объект не найден',
      permissionsStale: 'Права изменились в другой сессии. Обновите роль и попробуйте снова',
      phoneAlreadyExists: 'Этот телефон уже используется другой записью',
      callCenterOwnDuplicate: 'Вы уже отправляли лид с этим номером телефона',
      processNoAnsweredCarrier:
        'Невозможно отметить обработанной: ни один перевозчик ещё не ответил',
      reasonRequired: 'Укажите причину',
      requestItemMissingPhoto: 'Каждая позиция должна иметь 1 фото',
      returnBlockedByAnsweredCarrier:
        'Возврат недоступен: у перевозчиков есть отвеченные ставки. Сбросьте, отклоните или удалите их',
      winnerRequired: 'Выберите победившую ставку',
      shiftCannotLeaveLast: 'Нельзя уйти со смены: вы последний логист',
      storageForbidden: 'Нет доступа к файлу',
      userEmailTaken: 'Пользователь с таким email уже существует',
      userNotFound: 'Пользователь не найден',
      validation: 'Проверьте введённые данные',
    },
    generic: {
      unavailable: 'Сервис недоступен. Попробуйте ещё раз',
    },
    rateLimit: {
      exceeded: 'Слишком много попыток. Подождите минуту',
    },
  },
  rbac: {
    actions: {
      savePermissions: 'Сохранить права',
    },
    groups: {
      accounts: 'Счета',
      agent: 'AI-агент',
      arrivalCities: 'Города прибытия',
      audit: 'Журнал аудита',
      callCenterLeads: 'Лиды колл-центра',
      calls: 'Звонки',
      cargo: 'Грузы',
      cargoProblems: 'Проблемы грузов',
      carriers: 'Перевозчики',
      chat: 'Чаты',
      clients: 'Клиенты',
      commercialProposals: 'КП',
      logisticsCalculations: 'Расчёты по логистике',
      companies: 'Компании',
      dashboard: 'Дашборды',
      deals: 'Сделки',
      departments: 'Отделы',
      leads: 'Лиды',
      packaging: 'Упаковка',
      paymentClaims: 'Заявки на оплату',
      payments: 'Платежи',
      priceLists: 'Прайс-листы',
      requests: 'Заявки',
      roads: 'Дороги',
      roles: 'Роли',
      russiaCarriers: 'Перевозчики РФ',
      russiaRequests: 'Заявки Россия',
      sources: 'Источники',
      stages: 'Этапы',
      tasks: 'Задачи',
      transitions: 'Переходы заявок',
      transportTypes: 'Вид транспорта',
      users: 'Пользователи',
      warehouses: 'Склады',
      warehousesChina: 'Склады Китай',
    },
    permissions: {
      accounts: {
        manage: 'Управление счетами',
        read: 'Просмотр счетов',
      },
      agent: {
        admin: 'Администрирование AI-агента (промпты, отладка, SQL)',
      },
      arrivalCities: {
        manage: 'Управление городами прибытия',
        read: 'Просмотр городов прибытия',
      },
      audit: {
        read: 'Просмотр журнала аудита',
      },
      callCenterLeads: {
        readOwn: 'Просмотр своих лидов колл-центра',
        submit: 'Отправка лидов колл-центра',
      },
      calls: {
        manage: 'Управление звонками',
        read: 'Просмотр звонков',
      },
      cargo: {
        carrierPayment: {
          manage: 'Изменение статуса оплаты перевозчику',
        },
        chinaPayment: {
          manage: 'Изменение суммы оплаты в Китае',
        },
        clientPayment: {
          manage: 'Изменение статуса оплаты клиентом',
          quickManage: 'Быстрая отметка полной оплаты клиентом',
          review: 'Проверка оплаты клиентом (Финансист РФ)',
        },
        clientPaymentDocs: {
          manage: 'Управление платёжными документами клиента',
        },
        clientTariff: {
          manage: 'Изменение тарифа перевозки для клиента',
        },
        create: 'Создание груза',
        delete: 'Удаление груза',
        dictionaries: {
          manage: 'Управление справочниками грузов',
          read: 'Просмотр справочников грузов',
        },
        import: 'Импорт файлов грузов',
        manage: 'Управление грузами',
        read: 'Просмотр грузов',
        scope: {
          all: 'Просмотр всех грузов (снимает ограничение по владельцу)',
        },
        update: 'Изменение груза',
      },
      cargoProblems: {
        assignee: { manage: 'Переназначение ответственного за проблему' },
        attachments: { delete: 'Удаление опубликованных вложений проблемы' },
        create: 'Создание проблем грузов',
        read: 'Просмотр проблем грузов',
        scope: { all: 'Просмотр всех отправленных проблем грузов' },
        work: { china: 'Работа с очередью Китай', russia: 'Работа с очередью Россия' },
      },
      carriers: {
        manage: 'Управление перевозчиками',
        read: 'Просмотр перевозчиков',
      },
      chat: {
        manage: 'Управление чатами',
        read: 'Просмотр чатов',
      },
      clients: {
        manage: 'Управление клиентами',
        read: 'Просмотр клиентов',
      },
      commercialProposals: {
        manage: 'Управление КП',
        read: 'Просмотр КП',
      },
      logisticsCalculations: {
        manage: 'Управление расчётами по логистике',
        read: 'Просмотр расчётов по логистике',
      },
      companies: {
        manage: 'Управление компаниями',
        read: 'Просмотр компаний',
      },
      dashboard: {
        read: 'Просмотр дашбордов',
      },
      deals: {
        manage: 'Управление сделками',
        read: 'Просмотр сделок',
      },
      departments: {
        manage: 'Управление отделами',
        read: 'Просмотр отделов',
      },
      leads: {
        assign: 'Назначение лидов',
        manage: 'Управление лидами',
        read: 'Просмотр лидов',
        scope: {
          all: 'Видеть все лиды (снимает ограничение «только свои»)',
        },
      },
      packaging: {
        manage: 'Управление упаковкой',
        read: 'Просмотр упаковки',
      },
      paymentClaims: {
        manage: 'Управление заявками на оплату',
        read: 'Просмотр заявок на оплату',
      },
      payments: {
        manage: 'Управление платежами',
        read: 'Просмотр платежей',
      },
      priceLists: {
        manage: 'Управление прайс-листами',
        read: 'Просмотр прайс-листов',
      },
      requests: {
        export: { bulk: 'Массовый экспорт заявок' },
        manage: 'Управление заявками',
        read: 'Просмотр заявок',
        scope: {
          all: 'Видеть все заявки (снимает ограничение «только свои»)',
        },
        transition: {
          archive: 'Переход заявки: архивировать',
          close: 'Переход заявки: закрыть',
          process: 'Переход заявки: обработать',
          reopen: 'Переход заявки: вернуть в работу',
          return: 'Переход заявки: вернуть',
          send: 'Переход заявки: отправить',
          unarchive: 'Переход заявки: восстановить из архива',
          success: 'Переход заявки: оформить успех',
          refuse: 'Переход заявки: оформить отказ',
          postpone: 'Переход заявки: отложить',
          cannotTransport: 'Переход заявки: не можем везти',
        },
      },
      roads: {
        manage: 'Управление дорогами',
        read: 'Просмотр дорог',
      },
      roles: {
        manage: 'Управление ролями',
        read: 'Просмотр ролей',
      },
      russiaCarriers: {
        manage: 'Перевозчики РФ: управление',
        read: 'Перевозчики РФ: чтение',
      },
      russiaRequests: {
        manage: 'Управление заявками Россия',
        read: 'Просмотр заявок Россия',
        scope: {
          all: 'Видеть все заявки Россия (снимает ограничение «только свои»)',
        },
        transition: {
          archive: 'Переход заявки Россия: архивировать',
          close: 'Переход заявки Россия: закрыть',
          process: 'Переход заявки Россия: обработать',
          reopen: 'Переход заявки Россия: вернуть в работу',
          return: 'Переход заявки Россия: вернуть',
          send: 'Переход заявки Россия: отправить',
          unarchive: 'Переход заявки Россия: восстановить из архива',
          success: 'Переход заявки Россия: оформить успех',
          refuse: 'Переход заявки Россия: оформить отказ',
          postpone: 'Переход заявки Россия: отложить',
        },
      },
      sources: {
        manage: 'Управление источниками',
        read: 'Просмотр источников',
      },
      stages: {
        manage: 'Управление этапами',
        read: 'Просмотр этапов',
      },
      tasks: {
        manage: 'Управление задачами',
        read: 'Просмотр задач',
      },
      transportTypes: {
        manage: 'Управление видами транспорта',
        read: 'Просмотр видов транспорта',
      },
      users: {
        manage: 'Управление пользователями',
        read: 'Просмотр пользователей',
      },
      warehouses: {
        manage: 'Управление складами',
        read: 'Просмотр складов',
      },
      warehousesChina: {
        manage: 'Управление складами Китай',
        read: 'Просмотр складов Китай',
      },
    },
  },
  unreadBadge: {
    markedUnread: 'Помечено как непрочитанное',
    count_one: '{{count}} непрочитанное сообщение',
    count_few: '{{count}} непрочитанных сообщения',
    count_many: '{{count}} непрочитанных сообщений',
    count_other: '{{count}} непрочитанных сообщений',
    capped: 'Более {{count}} непрочитанных сообщений',
    attentionCount_one: '{{count}} проблема требует внимания',
    attentionCount_few: '{{count}} проблемы требуют внимания',
    attentionCount_many: '{{count}} проблем требуют внимания',
    attentionCount_other: '{{count}} проблем требуют внимания',
    attentionCapped: 'Более {{count}} проблем требуют внимания',
  },
  requests: {
    actions: {
      archive: 'В архив',
      close: 'Закрыть заявку',
      process: 'Отметить обработанной',
      processDisabledNoAnswered: 'Ожидаем ответ хотя бы одного перевозчика',
      reopen: 'Вернуть в работу',
      return: 'Вернуть на доработку',
      send: 'Отправить в работу',
      unarchive: 'Восстановить',
      success: 'Оформить успех',
      refuse: 'Оформить отказ',
      cannotTransport: 'Не можем везти',
      postpone: 'Отложить',
      duplicate: 'Дублировать',
      russiaRate: {
        button: 'Ставка по РФ',
        tooltip: {
          disabledEmptyCargo: 'Добавьте позицию или коробку, чтобы создать ставку по РФ.',
          openExisting: 'Открыть существующую ставку по РФ.',
          create: 'Создать ставку по РФ из этой заявки.',
          creating: 'Создаём ставку по РФ…',
          error: 'Не удалось создать ставку по РФ. Повторите попытку.',
        },
        create: {
          title: 'Создать заявку по РФ',
          addressLabel: 'Адрес доставки',
          addressRequired: 'Укажите адрес доставки.',
          confirm: 'Создать заявку',
          cancel: 'Отмена',
        },
      },
    },
    audit: {
      empty: 'Нет событий в журнале',
    },
    boxRegroup: {
      action: {
        edit: 'Изменить группы',
      },
      editor: {
        title: 'Переназначить товары по группам',
      },
      toast: {
        saved: 'Группы товаров обновлены',
        stale: 'Коробку обновил кто-то ещё. Обновите данные и повторите попытку.',
        overrideConflict:
          'Не удалось сохранить: у перевозчика закреплён тариф или страховка за группой, которая опустеет.',
        failed: 'Не удалось сохранить группы. Повторите попытку.',
      },
      conflicts: {
        title: 'Конфликты привязок',
        line: 'Группа {{ordinal}} ({{domain}}): {{carriers}}',
        domain: {
          bid: 'тариф',
          insurance: 'страховка',
        },
      },
    },
    export: {
      action: 'Скачать Excel',
      downloading: 'Готовим файл…',
      error: 'Не удалось скачать файл',
      bulk: {
        enterSelection: 'Выделить',
        selectAll: 'Выбрать все результаты',
        selectingAll: 'Выбираем…',
        clear: 'Очистить',
        exitSelection: 'Выйти',
        open: 'Сформировать файл',
        title: 'Массовый экспорт',
        confirm: 'Сформировать файл',
        includeRateColumns: 'Добавить поля для ставок',
        selectedCount_one: 'Выбрана {{count}} заявка',
        selectedCount_few: 'Выбрано {{count}} заявки',
        selectedCount_many: 'Выбрано {{count}} заявок',
        selectedCount_other: 'Выбрано {{count}} заявок',
        selectColumn: 'Выбор заявок',
        selectRequest: 'Выбрать заявку {{id}}',
        capReached: 'Можно выбрать не более 20 заявок.',
        tooMany: 'Найдено больше 20 заявок. Уточните фильтры и повторите попытку.',
        selectAllError: 'Не удалось выбрать все результаты. Повторите попытку.',
        missing: 'Не найдены или недоступны заявки: {{ids}}.',
        oversized: 'Заявка {{id}} слишком велика для экспорта.',
      },
    },
    funnel: {
      openLead: 'Открыть связанный лид {{code}}',
      openDeal: 'Открыть связанную сделку {{code}}',
    },
    errors: {
      detailFetchFailed: 'Не удалось загрузить заявку. Повторите попытку.',
    },
    rowGone: 'Заявка больше недоступна.',
    nextStep: {
      draft: {
        incomplete: 'Заполните недостающие поля и отправьте в работу. Осталось полей: {{count}}.',
        ready: 'Заявка готова — отправьте её в работу.',
      },
      return: {
        incomplete: 'Исправьте недостающие поля и отправьте повторно. Осталось полей: {{count}}.',
        ready: 'Исправления внесены — отправьте заявку повторно.',
      },
      draftReadyPending: 'Заявка заполнена.',
      returnReadyPending: 'Возврат оформлен.',
      readyForWork: 'Ожидаем, пока логист возьмёт заявку в работу.',
      waitingAnswers: 'Ожидаем ответы перевозчиков.',
      pickWinner: 'Есть ответы перевозчиков — выберите победителя.',
      pickWinnerPending: 'Ответы перевозчиков получены — ожидаем выбора победителя.',
      winnerSelected: 'Победитель выбран.',
      postponed: 'Заявка отложена',
      success: 'Заявка завершена успешно.',
      terminal: 'Заявка завершена. Действий не требуется.',
      action: {
        send: 'Отправить сейчас',
        pickWinner: 'Перейти к выбору',
      },
    },
    carriers: {
      add: 'Добавить',
      addBid: 'Добавить ставку',
      addBidTitle: 'Новая ставка — {{name}}',
      bid: {
        validUntil: 'Действует до {{date}}',
        notActualSince: 'Не актуально с {{date}}',
        validityDaysPlaceholder: 'Срок действия ставки, дн.',
        validityHint:
          'Срок действия — целое число дней от {{min}} до {{max}}. По умолчанию {{defaultDays}}.',
        validityPreset: {
          thisWeek: 'до конца этой недели',
          nextWeek: 'до конца следующей недели',
          days7: '7 дней',
          days10: '10 дней',
          days14: '14 дней',
          manual: 'свободный ввод',
        },
      },
      addPlaceholder: 'Выберите перевозчика',
      answer: 'Ответ',
      completedCount: 'Ответили {{completed}} из {{total}}',
      answerTitle: 'Ответ перевозчика — {{name}}',
      bestOffers: 'Лучшие предложения',
      bids: 'Ставки',
      cheapest: 'Дешевле всего',
      columns: {
        carrier: 'Перевозчик',
        comment: 'Комментарий',
        conditions: 'Условия',
        days: 'Срок',
        price: 'Ставка',
        sentAt: 'Отправлено',
        status: 'Статус',
      },
      commentPlaceholder: 'Комментарий перевозчика',
      contact: 'Связаться',
      daysMaxPlaceholder: 'Срок, дн. (макс.)',
      daysMinPlaceholder: 'Срок, дн. (мин.)',
      daysPlaceholder: 'Срок перевозки, дн. (необязательно)',
      destinationSection: {
        titleFull: 'Перевозчики — {{name}}',
        titleShort: 'Перевозчики — {{short}}',
      },
      generalSection: {
        title: 'Общие ставки',
      },
      errors: {
        carrierCityNotInRequest: 'Город назначения не входит в направления заявки.',
        carrierAlreadyInCity: 'Этот перевозчик уже добавлен на этот город.',
        carrierAlreadyInRequest: 'Этот перевозчик уже добавлен в заявку.',
      },
      insurance: {
        section: 'Страхование',
        noQuote: 'Пока нет ставки по страховке',
        addQuote: 'Добавить % страховки',
        addOverride: 'Добавить переопределение',
        reconfirm: 'Подтвердить',
        needsReconfirm: 'Стоимость груза изменилась — подтвердите',
        percentLabel: '%',
        percentValue: '{{percent}}%',
        amountLabel: 'Сумма',
        cargoValueLabel: 'Стоимость груза',
        commentLabel: 'Комментарий',
        commentPlaceholder: 'Необязательный комментарий',
        primary: {
          cannotDeleteWithOverrides:
            'Нельзя удалить основную ставку, пока есть переопределения. Сначала удалите переопределения.',
        },
        scope: {
          request: { label: 'Вся заявка' },
          item: { label: 'Позиция: {{name}}' },
          box: { label: 'Коробка №{{n}}' },
          boxItem: { label: 'Товар в коробке №{{n}}: {{name}}' },
          boxGroup: { label: 'Группа {{k}} в коробке №{{n}}' },
        },
        scopePicker: {
          placeholder: 'Выберите цель',
          required: 'Выберите цель',
          noOptions: 'Нет оставшихся областей для переопределения',
        },
        errors: {
          percentBounds: 'Процент должен быть от 0 до 100',
        },
      },
      daysShort: '{{days}} дн.',
      daysShortRange: '{{min}}–{{max}} дн.',
      editBidTitle: 'Изменить ставку — {{name}}',
      empty: 'Перевозчики ещё не приглашены',
      noBids: 'Пока нет ставок',
      pickWinner: 'Выбрать победителя',
      pricePerUnitPlaceholder: 'Цена за единицу',
      pricePlaceholder: 'Стоимость доставки',
      reject: 'Отказ',
      rejectPlaceholder: 'Причина отказа',
      rejectTitle: 'Отказ перевозчика — {{name}}',
      reset: 'В ожидание',
      state: {
        answered: 'Ответил',
        pending: 'Ожидаем',
        rejected: 'Отказ',
      },
      total: 'Итого',
      unitKg: 'за кг',
      unitM3: 'за м³',
      unitPiece: 'за шт.',
      unitSuffix: {
        kg: '/кг',
        m3: '/м³',
        piece: '/шт.',
      },
      winner: 'победитель',
    },
    chat: {
      aria: {
        read: 'Прочитано получателем',
        sent: 'Отправлено',
      },
      empty: 'Пока нет сообщений',
      markUnread: 'Пометить как непрочитанное',
      newDivider: 'Новые',
      placeholder: 'Сообщение как {{name}}…',
      roles: {
        admin: 'админ',
        logist_cn: 'логист китай',
        logist_ru: 'логист рф',
        manager: 'менеджер',
      },
      send: 'Отправить',
      unmarkUnread: 'Снять отметку',
    },
    closeModal: {
      confirm: 'Подтвердить закрытие',
      noWinner: 'Перед закрытием нужно выбрать победителя — сервер требует этого.',
      pickWinner: 'Выберите победителя из ответивших перевозчиков.',
      title: 'Закрыть заявку — {{id}}',
      winnerText: 'Заявка перейдёт в статус «Закрыто». Победитель — {{name}}.',
    },
    common: {
      attachments: 'Вложения',
      autoSave: 'Автосохранение',
      createdAt: 'Создано {{date}}',
      days: '{{count}} дн',
      density: 'Плотность, кг/м³',
      from: 'Откуда',
      guest: 'Гость',
      items: 'Позиции',
      logist_cn: 'Логист Китай',
      manager: 'Менеджер',
      noName: '(без названия)',
      notAssigned: 'не назначен',
      route: 'Маршрут',
      to: 'Куда',
      updatedAt: 'Обновлено',
      volume: 'Объём',
      weight: 'Вес',
    },
    draftDefaults: {
      from: 'Китай',
      to: 'Россия',
    },
    returnTemplates: {
      cancel: 'Хочу отменить заявку',
      addItems: 'Нужно добавить позиций',
      removeItems: 'Нужно удалить позиции',
      adjustWeightVolume: 'Нужно скорректировать вес / объём',
      attachPacking: 'Нужно приложить пакинг',
    },
    draft: {
      addItem: 'Добавить позицию',
      deleteDraft: 'Удалить черновик',
      deleteReturn: 'Удалить возврат',
      duplicateItem: 'Дублировать',
      emptyItems: 'Добавьте хотя бы одну позицию груза',
      frozen: {
        banner:
          'Черновик сохранён на сервере. Чтобы изменить — начните заново или попробуйте отправить снова.',
      },
      fromPlaceholder: 'Город отправки в Китае',
      itemDescriptionPlaceholder: 'Кратко опишите позицию, состав или особенности упаковки',
      itemNamePlaceholder: 'Название позиции',
      newItemName: 'Новая позиция',
      photoAttached: 'Фото загружено',
      photoAddMore: 'Добавить ещё фото',
      photoRemove: 'Удалить фото',
      photoReplace: 'Заменить фото',
      photoRetry: 'Повторить',
      photoUpload: 'Загрузить фото',
      photoUploading: 'Загрузка…',
      photoFromClipboard: 'Добавить фото из буфера',
      ready: 'Готово к отправке логисту',
      photoDecodeFailed: 'Браузер не смог декодировать формат изображения: {{format}}.',
      photoEncodeFailed: 'Браузер не смог подготовить изображение к загрузке.',
      photoUploadFailed: 'Не удалось загрузить — попробуйте снова',
      startOver: 'Начать заново',
      save: 'Сохранить черновик',
      saveReturn: 'Сохранить возврат',
      saving: 'Сохраняется…',
      savedReady: 'Сохранено',
      unsavedDraft: 'Черновик не сохранён',
      unsavedChanges: 'Есть несохранённые изменения',
      confirmDiscard: 'У черновика есть несохранённые изменения. Закрыть и потерять их?',
      closeConfirm: {
        titleUnsaved: 'Сохранить черновик?',
        titlePersisted: 'Сохранить изменения в черновике?',
        bodyUnsaved:
          'У черновика есть несохранённые изменения. Сохранить и закрыть, или закрыть без сохранения?',
        bodyPersisted:
          'В черновике есть несохранённые изменения. Сохранить и закрыть, или закрыть без сохранения?',
        saveAndClose: 'Сохранить и закрыть',
        continueEditing: 'Продолжить редактирование',
        closeWithoutSaving: 'Закрыть без сохранения',
        confirmCloseWithoutSaving: 'Точно закрыть без сохранения?',
        discardArmedHint: 'Это действие нельзя отменить.',
        uploadingHint:
          'Дождитесь завершения загрузки фото — пока сохранение и закрытие недоступны.',
      },
      deleteConfirm: {
        confirm: 'Точно удалить?',
        hint: 'Это действие нельзя отменить.',
        uploadingHint: 'Дождитесь окончания загрузки фото.',
      },
      photoClipboard: {
        unsupported: 'Браузер не поддерживает чтение буфера обмена.',
        denied: 'Доступ к буферу обмена запрещён.',
        empty: 'В буфере нет подходящего изображения.',
        failed: 'Не удалось получить изображение из буфера.',
        unsupportedType: 'Этот тип изображения не поддерживается.',
      },
      photoReplaceConfirm: {
        title: 'Заменить фото?',
        body: 'У позиции уже есть фото. Заменить его новым из буфера?',
        confirm: 'Заменить',
        cancel: 'Отмена',
      },
      destinations: {
        label: 'Город(а) доставки',
        empty: 'Город(а) ещё не выбран(ы)',
        add: 'Добавить',
        pickerPlaceholder: 'Выберите город',
        remove: 'Убрать {{name}}',
      },
      deliveryAddress: {
        label: 'Адрес доставки',
        placeholder: 'Город, улица, дом, склад или контакт получателя',
      },
      pickupAddress: {
        label: 'Адрес вывоза',
        placeholder: 'Город, улица, дом, склад или контакт отправителя',
      },
      roads: {
        label: 'Дороги',
        empty: 'Дороги не выбраны',
        add: 'Добавить',
        pickerPlaceholder: 'Выберите дорогу',
        remove: 'Убрать {{name}}',
        catalogEmptyHint: 'В справочнике нет активных значений. Обратитесь к логисту Китай.',
        catalogEmptyLink: 'Перейти к справочнику →',
      },
      packaging: {
        label: 'Упаковка',
        empty: 'Упаковка не выбрана',
        add: 'Добавить',
        pickerPlaceholder: 'Выберите упаковку',
        remove: 'Убрать {{name}}',
        catalogEmptyHint: 'В справочнике нет активных значений. Обратитесь к логисту Китай.',
        catalogEmptyLink: 'Перейти к справочнику →',
      },
      dictionarySelections: {
        inactiveSuffix: '(неактивно)',
      },
      container: {
        transportTypeLabel: 'Тип транспорта',
        pickerPlaceholder: 'Выберите тип транспорта',
        capacityHint: '{{volumeMin}}–{{volumeMax}} м³ · {{payloadMin}}–{{payloadMax}} т',
      },
      insurance: {
        section: 'Страхование',
        toggleLabel: 'Нужна информация по страховке',
        cargoValueLabel: 'Стоимость груза',
        cargoValuePlaceholder: 'Напр. 12000',
        cargoCurrencyLabel: 'Валюта',
        cargoCurrencyPlaceholder: 'Выберите валюту',
      },
      required: {
        deliveryAddress: 'Адрес доставки контейнера',
        pickupAddress: 'Адрес вывоза контейнера',
        destinations: 'Хотя бы 1 город доставки',
        from: 'Откуда',
        insuranceTriplet: 'Стоимость груза и валюта для страховки',
        item: 'Хотя бы 1 позиция',
        itemOrBox: 'Добавьте хотя бы 1 позицию или коробку',
        itemDescription: 'Описание для каждой позиции',
        itemName: 'Название для каждой позиции',
        itemPhoto: 'Фото для каждой позиции',
        itemQuantity: 'Количество для каждой позиции',
        itemVolume: 'Объём больше 0 для каждой позиции',
        itemWeight: 'Вес больше 0 для каждой позиции',
        boxItem: 'Хотя бы 1 позиция в каждой коробке',
        boxItemName: 'Название для каждой позиции коробки',
        boxItemDescription: 'Описание для каждой позиции коробки',
        boxItemPhoto: 'Фото для каждой позиции коробки',
        boxItemQuantity: 'Кол-во больше 0 для каждой позиции коробки',
        name: 'Название',
        prefix: 'Заполните:',
        to: 'Куда',
        transportType: 'Тип транспорта',
        weight: 'Вес больше 0',
        volume: 'Объём больше 0',
      },
      saved: 'Сохранено {{time}}',
      sections: {
        basics: 'Основное',
        items: 'Позиции · {{count}}',
        dictionarySelections: 'Дороги и упаковка',
        files: 'Файлы и фото',
      },
      containerTotals: {
        section: 'Вес и габариты',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
      },
      standardTotals: {
        section: 'Вес и габариты',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
      },
      table: {
        brand: 'Бренд',
        description: 'Описание',
        material: 'Материал',
        name: 'Наименование',
        photo: 'Фото',
        // WHY (#1056): renamed to «Кол-во мест» (places count) so a
        //   logist reading the editor sees the explicit logistics
        //   meaning. `productQuantity` below is the canonical SKU
        //   count and is edited independently.
        quantity: 'Кол-во мест',
        placesCount: 'Кол-во мест',
        productQuantity: 'Кол-во товара',
        volume: 'Объём, м³',
        weight: 'Вес, кг',
      },
      packages: {
        toggle: 'Указать габариты и места',
        addPlace: 'Добавить место',
        removePlace: 'Удалить место',
        place: 'Место {{index}}',
        widthCm: 'Ширина, см',
        depthCm: 'Глубина, см',
        heightCm: 'Высота, см',
        weightKg: 'Вес 1 места, кг',
        count: 'Кол-во мест',
        perPackageVolume: 'Объём 1 места, м³',
        rowVolume: 'Объём строки, м³',
        itemTotal: 'Итого по позиции',
        itemTotalWeight: 'Вес: {{value}} кг',
        itemTotalVolume: 'Объём: {{value}} м³',
        itemTotalQuantity: 'Мест: {{value}}',
        hint: 'Вес и объём позиции рассчитываются автоматически по списку мест.',
        emptyPlaces: 'Добавьте хотя бы одно место',
        mobileSummary: '{{w}} × {{d}} × {{h}} см · {{weight}} кг · {{count}} шт',
      },
      boxes: {
        sectionTitle: 'Коробки',
        emptyHint: 'Здесь можно добавить коробки с вложенными позициями.',
        addBox: 'Добавить коробку',
        removeBox: 'Удалить коробку',
        boxLabel: 'Коробка {{index}}',
        count: 'Кол-во',
        weightKg: 'Вес 1 кор., кг',
        volumeM3: 'Объём 1 кор., м³',
        volumeMode: 'Режим объёма',
        modeDirect: 'Указать напрямую',
        modeDimensions: 'По размерам',
        widthCm: 'Ширина, см',
        depthCm: 'Глубина, см',
        heightCm: 'Высота, см',
        contents: 'Содержимое коробки',
        contentsEmpty: 'Пока пусто. Добавьте позицию.',
        addItem: 'Добавить позицию',
        removeItem: 'Удалить позицию',
        itemName: 'Название',
        itemBrand: 'Бренд',
        itemMaterial: 'Материал',
        itemDescription: 'Описание',
        itemQuantity: 'Кол-во',
        itemPhoto: 'Фото позиции',
        itemPhotoMissing: 'Без фото',
        groups: {
          action: {
            assign: 'Группа',
            newGroup: '+ Новая группа',
          },
          label: {
            group: 'Группа {{ordinal}}',
          },
          tooltip: {
            cannotShipTogether: 'Эти позиции нельзя везти вместе',
          },
        },
      },
      titleLabel: 'Название заявки',
      titlePlaceholder: 'Напр. Сантехника Foshan, поставка 05/26',
      toPlaceholder: 'Город доставки',
      returnReasonBanner: {
        title: 'Заявка возвращена логистом',
        bodyPrefix: 'Причина:',
      },
    },
    containerTotalsBackfill: {
      save: 'Сохранить',
      saved: 'Сохранено',
      error: 'Ошибка сохранения',
    },
    format: {
      justNow: 'только что',
      remaining: 'Осталось {{value}}',
      completedIn: 'Выполнено за {{value}}',
      overdue: 'Просрочено на {{value}}',
      yesterdayAt: 'вчера, {{time}}',
    },
    filters: {
      slaHot: 'Горит',
      slaOverdue: 'Просрочено',
      unread: 'Непрочитано',
      kindStandard: 'Сборные',
      kindContainer: 'Контейнеры',
      kindSimple: 'Простые',
    },
    list: {
      all: 'Все',
      columns: {
        answers: 'Ответы',
        cargo: 'Груз',
        density: 'Плотность, кг/м³',
        manager: 'Менеджер',
        messages: 'Сообщения',
        name: 'Название',
        deadlines: 'Сроки',
        status: 'Статус',
        updated: 'Обновлено',
        volume: 'Объём',
        weight: 'Вес',
      },
      row: {
        containerBadge: 'Контейнер',
        containerDestination: 'До адреса клиента',
        createdPrefix: 'Созд.',
        densitySuffix: 'кг/м³',
        simpleBadge: 'Простая',
        updatedPrefix: 'Обн.',
        volumeSuffix: 'объём',
        weightSuffix: 'вес',
      },
      answersBar: {
        tooltip: 'Всего {{total}} · Тариф {{tariff}} · Отказ {{rejected}} · Ждём {{pending}}',
      },
      empty: 'Нет заявок, соответствующих фильтру',
      filters: 'Фильтры',
      filterPanel: {
        title: 'Фильтры',
        dateRange: 'Создано',
        dateFrom: 'С',
        dateTo: 'По',
        weightRange: 'Вес (кг)',
        volumeRange: 'Объём (м³)',
        rangeMin: 'мин',
        rangeMax: 'макс',
        manager: 'Менеджер',
        managerAll: 'Все менеджеры',
        managerSelectedCount_one: 'Выбран {{count}} менеджер',
        managerSelectedCount_few: 'Выбрано {{count}} менеджера',
        managerSelectedCount_many: 'Выбрано {{count}} менеджеров',
        managerSelectedCount_other: 'Выбрано {{count}} менеджеров',
        clearAdvanced: 'Очистить расширенные',
      },
      loadMore: 'Загрузить ещё',
      loadingMore: 'Загружаем…',
      loading: 'Загрузка…',
      error: 'Не удалось загрузить заявки',
      newRequest: 'Сложная заявка',
      newContainer: 'Новый контейнер',
      newSimple: 'Простая заявка',
      searchPlaceholder: 'Найти по ID или названию',
      statusesToggle: 'Статусы',
      title: 'Запрос логистики',
    },
    items: {
      empty: 'Позиции не добавлены',
    },
    photoGallery: {
      counter: 'Фото {{current}} из {{total}}',
      prev: 'Назад',
      next: 'Вперёд',
      close: 'Закрыть',
    },
    photo: {
      moreBadge: '+{{count}}',
    },
    pickWinnerModal: {
      confirm: 'Назначить победителем',
      empty: 'Нет ответов от перевозчиков — выбирать пока не из кого.',
      title: 'Выбрать победителя — {{id}}',
    },
    successModal: {
      confirm: 'Оформить успех',
      title: 'Успех — {{id}}',
      winnerText: 'Победитель — {{name}}.',
      noBids:
        'У заявки нет отвеченных перевозчиков. Дождитесь ответов или верните заявку в работу.',
      expiredWarning:
        'Эта ставка истекла {{date}}. Перед фиксацией успеха уточните цену у перевозчика.',
    },
    refuseModal: {
      confirm: 'Оформить отказ',
      title: 'Отказ — {{id}}',
      explanation: 'Заявка перейдёт в статус «Отказ». Победитель будет снят, если был выбран.',
      reason: {
        quoteResponseTooSlow: 'Перевозчики долго отвечают',
        priceNotAccepted: 'Клиента не устроила цена',
        clientUnresponsive: 'Клиент не выходит на связь',
        other: 'Другая причина',
      },
      commentLabel: 'Комментарий (необязательно)',
      commentPlaceholder: 'Подробности отказа для коммерческой команды',
      commentHint: 'Виден только команде, не уходит в журнал аудита',
    },
    refusalDetails: {
      reasonMissing: 'Причина не указана',
      title: 'Причина отказа',
    },
    returnModal: {
      explanation:
        'Заявка вернётся в статус «Возврат». Менеджер увидит причину и должен внести правки.',
      presets: {
        missingDescription: 'Нет описания товаров: материалы изготовления, область применения;',
        weightVolume: 'Проверь данные по весу и объёму.',
      },
      presetsTitle: 'Шаблоны причин',
      reasonLabel: 'Причина возврата',
      reasonPlaceholder: 'Опишите, что нужно уточнить или исправить',
      submit: 'Вернуть менеджеру',
      title: 'Вернуть на доработку — {{id}}',
    },
    cannotTransportModal: {
      title: 'Не можем везти — заявка {{id}}',
      explanation:
        'Заявка перейдёт в статус «Не можем везти». Это конечный статус: перевозчики и ставки сохранятся, но менеджер увидит заявку как закрытую с нашей стороны.',
      reasonLabel: 'Причина',
      reasonPlaceholder: 'Опишите, почему мы не можем везти этот груз',
      submit: 'Отметить «не можем везти»',
    },
    reopenModal: {
      explanation:
        'Заявка вернётся в статус «В работе». Выбор победителя будет сброшен, SLA перезапустится — можно сделать новый круг подбора.',
      reasonLabel: 'Причина возврата в работу',
      reasonPlaceholder: 'Опишите, почему заявке нужен новый круг подбора',
      submit: 'Вернуть в работу',
      title: 'Вернуть в работу — {{id}}',
    },
    roleSubtitle: {
      admin: 'Полный доступ: мониторинг, реопен, переназначения',
      logist_cn: 'Вы обрабатываете активный пул и управляете ставками',
      manager: 'Вы создаёте заявки и выбираете победителя',
    },
    status: {
      archive: 'Архив',
      closed: 'Закрыто',
      draft: 'Черновик',
      inWork: 'В работе',
      processed: 'Обработано',
      clientDecision: 'Решение?',
      readyForWork: 'К работе',
      return: 'Возврат',
      success: 'Успех',
      refused: 'Отказ',
      postponed: 'Отложено',
      cannotTransport: 'Не можем везти',
    },
    store: {
      created: 'Создана заявка',
      defaultDraftName: 'Новая заявка (черновик)',
      returnChatPrefix: '⤴ Возврат: {{reason}}',
      transition: {
        archive: 'В архив',
        close: 'Заявка закрыта',
        process: 'Отмечено обработанной',
        return: 'Возврат на доработку',
        send: 'Отправлено в работу',
        unarchive: 'Восстановлено из архива',
        success: 'Зафиксирован успех',
        refuse: 'Зафиксирован отказ',
        postpone: 'Заявка отложена',
      },
      winnerSelected: 'Выбран победитель: {{name}}',
    },
    tabs: {
      archive: 'Архив',
      archiveCount: 'Архив ({{count}})',
      audit: 'Журнал',
      auditCount: 'Журнал ({{count}})',
      carriers: 'Перевозчики ({{count}})',
      chat: 'Чат ({{count}})',
      files: 'Файлы',
      filesCount: 'Файлы ({{count}})',
      items: 'Позиции ({{count}})',
      returnBanner: 'Возврат на доработку',
    },
    archive: {
      empty: 'Возвратов пока нет',
      returnedAt: 'Возвращено: {{date}}',
      backToRequest: 'Назад к заявке',
      snapshotTitle: 'Снимок возврата',
      carriersEmpty: 'В этом снимке нет перевозчиков',
      loadError: 'Не удалось загрузить архив',
    },
    table: {
      brand: 'Бренд',
      description: 'Описание',
      material: 'Материал',
      photos: 'Фото',
      // WHY (#1056): renamed read-view header to «Кол-во мест». The
      //   sibling `productQuantity` is the new SKU column added next
      //   to it on the items table; nested-box surfaces relabel their
      //   own «quantity» as productQuantity since nested rows carry
      //   the product count per box, not places.
      quantity: 'Кол-во мест',
      placesCount: 'Кол-во мест',
      productQuantity: 'Кол-во товара',
      title: 'Наименование',
    },
    unavailable: {
      title: 'Заявка недоступна',
    },
    files: {
      add: 'Добавить файл',
      uploading: 'Загрузка…',
      usage: 'Файлов: {{count}} из {{max}}',
      saveFirst: 'Сначала сохраните черновик, чтобы прикреплять файлы.',
      capReached: 'Достигнут лимит файлов для заявки.',
      empty: 'Файлы ещё не прикреплены',
      download: 'Скачать',
      remove: 'Удалить',
      errors: {
        wrongType: 'Этот тип файла не поддерживается',
        tooLarge: 'Файл слишком большой',
        uploadFailed: 'Не удалось загрузить — попробуйте снова',
        downloadFailed: 'Не удалось скачать файл',
        listFailed: 'Не удалось загрузить список файлов',
        removeFailed: 'Не удалось удалить файл',
      },
    },
  },
  cargoProblems: {
    title: 'Грузы: проблемы',
    actions: {
      back: 'Назад',
      cancel: 'Отмена',
      close: 'Закрыть',
      confirm: 'Подтвердить',
      create: 'Создать проблему',
      delete: 'Удалить',
      edit: 'Редактировать',
      editAndResubmit: 'Исправить и отправить снова',
      evaluate: 'Оценить решение',
      claim: 'Взять в работу',
      reject: 'Отклонить',
      reassign: 'Сменить ответственного',
      retryPublish: 'Повторить публикацию',
      save: 'Сохранить',
      submit: 'Отправить',
      submitReview: 'Передать на проверку',
      publish: 'Сообщить о проблеме',
    },
    list: {
      subtitle: 'Проблем: {{count}}',
      empty: 'Проблем по выбранным условиям нет',
      capped: 'Показаны первые 300 проблем.',
      columns: {
        attention: 'Внимание',
        cargo: 'Груз',
        category: 'Категория',
        description: 'Описание',
        status: 'Статус',
        assignee: 'Ответственный',
        updatedAt: 'Обновлено',
        tariff: 'Тариф',
        dimensions: 'Вес / объём',
        carrier: 'Перевозчик',
      },
    },
    filters: {
      toggle: 'Фильтры',
      search: 'Поиск',
      searchPlaceholder: 'Описание, комментарий, артикул или название',
      status: 'Статус',
      category: 'Категория',
      queue: 'Очередь',
      author: 'Автор',
      assignee: 'Ответственный',
      carrier: 'Перевозчик',
      createdFrom: 'Создано с',
      createdTo: 'Создано по',
      updatedFrom: 'Обновлено с',
      updatedTo: 'Обновлено по',
      overdueOnly: 'Только с просроченной реакцией',
    },
    statuses: {
      DRAFT: 'Черновик',
      NEW: 'Новая',
      REJECTED: 'Отклонена',
      IN_PROGRESS: 'В работе',
      REVIEW: 'Проверка',
      NOT_RESOLVED: 'Не решена',
      PARTIALLY_RESOLVED: 'Частично решена',
      RESOLVED: 'Решена',
    },
    categories: {
      SUPPLIER: 'Поставщик',
      CHINA_WAREHOUSE: 'Склад Китай',
      CHINA_CARRIER: 'Перевозчик Китай',
      RUSSIA_WAREHOUSE: 'Склад РФ',
      RUSSIA_CARRIER: 'Перевозчик РФ',
    },
    queues: { CHINA_LOGISTICS: 'Логист Китай', RUSSIA_LOGISTICS: 'Логист РФ' },
    events: {
      SUBMITTED: 'Проблема отправлена',
      REJECTED: 'Проблема отклонена',
      CLAIMED: 'Проблема взята в работу',
      REVIEW_SUBMITTED: 'Решение отправлено на проверку',
      EVALUATED: 'Решение оценено',
      EDITED: 'Проблема изменена',
      RESUBMITTED: 'Проблема отправлена повторно',
      COMMENT_ADDED: 'Добавлен комментарий',
      FILE_UPLOADED: 'Прикреплён файл',
      ASSIGNEE_CHANGED: 'Изменён исполнитель',
      ATTACHMENT_DELETED: 'Вложение удалено',
    },
    summary: {
      label: 'Сводные счётчики проблем',
      status: 'Статусы',
      category: 'Категории',
      queue: 'Очереди',
    },
    editor: {
      editEyebrow: 'Редактирование проблемы',
      createEyebrow: 'Новая проблема',
      newTitle: 'Черновик проблемы',
      cargo: 'Груз',
      cargoSearch: 'Введите артикул или название',
      category: 'Категория',
      queue: 'Очередь',
      description: 'Кратко опишите, что произошло',
      contextSection: 'Контекст груза',
      briefSection: 'Суть проблемы',
      ownershipSection: 'Направление и ответственный',
      attachmentsSection: 'Исходные материалы',
      attachments: 'Вложения',
      assignee: 'Ответственный',
      assigneePlaceholder: 'Выберите активного сотрудника',
      assigneeUnavailable: 'недоступен',
      assigneeUnavailableHelp:
        'Этот сотрудник больше не подходит для назначения. Выберите активного ответственного.',
      privateDraft: 'Черновик сохранён и до публикации виден только вам.',
      privateDraftRetry:
        'Публикация не удалась. Черновик и готовые файлы сохранены — можно повторить.',
    },
    validation: {
      cargoRequired: 'Выберите груз',
      categoryRequired: 'Выберите категорию',
      queueRequired: 'Выберите очередь',
      descriptionRequired: 'Введите описание',
      assigneeRequired: 'Выберите активного ответственного',
      noteRequired: 'Введите комментарий',
      outcomeRequired: 'Выберите результат',
    },
    detail: {
      problem: 'Проблема',
      summary: 'Сводка проблемы',
      provenance: 'Подробности',
      workCard: 'Текущая работа',
      briefMaterials: 'Исходные материалы',
      terminalReadOnly: 'Проблема завершена. Карточка работы и история доступны только для чтения.',
      category: 'Категория',
      queue: 'Очередь',
      author: 'Автор',
      assignee: 'Ответственный',
      createdAt: 'Создано',
      updatedAt: 'Обновлено',
      reactionDueAt: 'Срок реакции',
      notApplicable: 'Не применяется',
      description: 'Описание',
      cargo: 'Груз',
      openCargo: 'Открыть {{cargo}} в реестре грузов',
      outcome: 'Результат',
    },
    timeline: {
      title: 'Техническая история',
      empty: 'История пока пуста',
      hint: 'Только служебные события: статусы, ответственные, удаления материалов.',
    },
    workspace: {
      conversation: 'Обсуждение',
      materials: 'Материалы',
      loadOlder: 'Показать более ранние',
      empty: 'Сообщений пока нет',
      conversationError: 'Не удалось загрузить обсуждение.',
      retry: 'Повторить',
      actionRequired: 'Нужно действие',
      systemCard: 'Служебное событие',
      assigneeChange: '{{from}} → {{to}}',
      attachmentDeleted: 'Вложение удалено. Причина: {{reason}}',
    },
    message: {
      label: 'Сообщение',
      placeholder: 'Напишите сообщение',
      send: 'Отправить',
      sent: 'Сообщение отправлено',
      reply: 'Ответить',
      replyingTo: 'Ответ: {{author}}',
      cancelReply: 'Отменить ответ',
      replyUnavailable: 'Исходное сообщение недоступно',
      documentNeedsText: 'К документу добавьте короткое пояснение',
      attachmentsPending: 'Дождитесь загрузки вложений',
      empty: 'Напишите сообщение или прикрепите файл',
      tooLong: 'Сообщение длиннее {{max}} знаков',
    },
    attachments: {
      add: 'Прикрепить файлы',
      remove: 'Убрать {{name}}',
      retry: 'Повторить загрузку {{name}}',
      statusUploading: '{{name}}: загрузка',
      statusReady: '{{name}}: готово',
      statusError: '{{name}}: ошибка загрузки',
      previous: 'Предыдущий файл',
      next: 'Следующий файл',
      download: 'Скачать',
      noPreview: 'Предпросмотр для этого типа файла недоступен',
      previewError: 'Не удалось открыть файл',
    },
    library: {
      title: 'Материалы',
      search: 'Поиск по имени файла',
      empty: 'Материалов пока нет',
      filters: { ALL: 'Все', MEDIA: 'Медиа', DOCUMENTS: 'Документы' },
      error: 'Не удалось загрузить материалы.',
      jump: 'Показать в обсуждении',
      jumpBrief: 'Показать в заявке',
      brief: 'Исходная заявка',
      delete: 'Удалить материал',
      deleteTitle: 'Удалить материал?',
      deleteText: 'Файл перестанет открываться у всех участников. Причину увидят участники.',
      deleteReason: 'Причина удаления',
      deleted: 'Материал удалён',
      uploadedBy: '{{author}} · {{date}}',
    },
    files: {
      attach: 'Прикрепить файл',
      uploading: 'Загрузка…',
      uploaded: 'Файл прикреплён',
      selected: 'Выбрано: {{count}}',
      selectedList: 'Выбранные вложения',
      remove: 'Удалить {{name}}',
      errors: {
        count: 'Можно прикрепить не больше 10 файлов',
        type: 'Этот тип файла не поддерживается',
        size: 'Файл слишком большой',
        name: 'Имя файла слишком длинное',
        upload: 'Не удалось прикрепить файл',
      },
    },
    toasts: {
      created: 'Черновик проблемы создан',
      published: 'Проблема опубликована',
      resubmitted: 'Проблема исправлена и отправлена снова',
      saved: 'Изменения сохранены',
      transitioned: 'Статус проблемы обновлён',
      reassigned: 'Ответственный изменён',
      deleted: 'Черновик проблемы удалён',
    },
    reassign: {
      title: 'Сменить ответственного',
      current: 'Сейчас отвечает',
      currentUnavailableHelp:
        'Текущий ответственный больше не подходит для этой очереди. Выберите доступного сотрудника.',
      next: 'Новый ответственный',
      loadError: 'Не удалось загрузить доступных сотрудников.',
      slaHelp: 'После переназначения срок реакции начнётся заново.',
    },
    noteTitles: {
      label: 'Комментарий',
      reject: 'Причина отклонения',
      submitReview: 'Описание решения',
      evaluate: 'Оценка решения',
    },
    delete: {
      title: 'Удалить черновик?',
      text: 'Черновик и вся его история будут удалены без возможности восстановления.',
    },
    dimensions: { weight: 'Вес', volume: 'Объём' },
    cargoUnavailable: 'Данные груза больше недоступны',
    unassigned: 'Не назначен',
    overdue: 'Просрочено',
  },
  cargo: {
    title: 'Грузы',
    loading: 'Загрузка…',
    error: 'Не удалось загрузить грузы',
    empty: 'Грузов пока нет',
    actions: {
      import: 'Импорт',
      add: 'Добавить',
      filters: 'Фильтры',
      resetFilters: 'Сбросить',
      delete: 'Удалить груз',
      reportProblem: 'Сообщить о проблеме',
      createTtn: 'Создать ТТН',
    },
    ttnInternalCosts: {
      chinaPayment: 'Оплата по Китаю',
      warehouseDispatch: 'Отправка со склада Китай',
      warehouseInspection: 'Проверка на складе Китай',
      warehousePackaging: 'Упаковка на складе Китай',
    },
    mirror: {
      banner:
        'Режим только для чтения: на время миграции источник данных — NextKargo. Редактирование недоступно.',
    },
    list: {
      searchPlaceholder: 'Поиск по артикулу',
      loadMore: 'Загрузить ещё',
      loadingMore: 'Загрузка…',
    },
    filters: {
      all: 'Все',
      status: 'Статус',
      manager: 'Менеджер',
      carrier: 'Перевозчик',
      carrierPlaceholder: 'Точное название',
      pathFormat: 'Дорога',
      clientPaymentStatus: 'Оплата клиентом',
      carrierPaymentStatus: 'Оплата перевозчику',
      weightRange: 'Вес (кг)',
      volumeRange: 'Объём (м³)',
      totalCostRange: 'Итоговая стоимость',
      rangeFrom: 'От',
      rangeTo: 'До',
      dateType: 'Тип даты',
      dateFrom: 'Дата с',
      dateTo: 'Дата по',
      overdue: 'Просрочка',
      hasRejectedDocument: 'Отклонённый документ',
      hasRejectedDocumentHint: 'С отклонённым документом',
    },
    lifecycle: {
      in_transit: 'В пути',
      arrived_not_issued: 'Прибыл в РФ',
      issued: 'Выдан',
    },
    activeFilters: {
      search: 'Поиск',
      dateRange: '{{range}}',
      from: 'от {{value}}',
      to: 'до {{value}}',
      clear: 'Сбросить фильтр «{{label}}»',
    },
    dateTypes: {
      china_ship: 'Дата отправки с Китая',
      arrival: 'Дата прибытия',
      issue: 'Дата выдачи',
    },
    overdue: {
      '1plus': 'От 1 дня',
      '7plus': 'От 7 дней',
    },
    status: {
      issued: 'Выдан',
    },
    cells: {
      noManager: 'Без менеджера',
      deleteDisabled: 'Удаление (скоро)',
    },
    tariff: {
      saved: 'Тариф сохранён',
    },
    delete: {
      title: 'Удалить груз',
      text: 'Удалить груз «{{article}}»? Действие можно отменить через восстановление.',
      toast: 'Груз удалён',
    },
    forms: {
      addTitle: 'Новый груз',
      editTitle: 'Груз «{{article}}»',
      unset: 'Не задано',
      fields: {
        article: 'Артикул',
        manager: 'Менеджер',
        carrier: 'Перевозчик',
        pathFormat: 'Дорога',
        status: 'Статус',
        nameGoods: 'Товар',
        numberOfSeats: 'Кол-мест',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
        transportationTariff: 'Тариф',
        transportationTariffForClients: 'Тариф перевозки клиенту',
        costGoods: 'Цена товара',
        insuranceCost: 'Цена страховки',
        packagingCost: 'Цена упаковки',
        timeFromChina: 'Дата отправки с Китая',
        totalCost: 'Итоговая стоимость перевозки',
        addressTransportationCost: 'Адресная доставка',
        chinaPaymentAmount: 'Получение груза, Китай',
        chinaWarehouseDispatchAmount: 'Отправка со склада, Китай',
        chinaWarehouseInspectionAmount: 'Проверка на складе, Китай',
        chinaWarehousePackagingAmount: 'Упаковка на складе, Китай',
        prr: 'ПРР',
        tatCost: 'Оплата ТАТ',
        paymentToCarrierStatus: 'Оплачено перевозчику',
        timeCargoArrivalToRf: 'Дата прибытия груза в РФ',
        timeCargoRelease: 'Дата выдачи груза',
      },
      errors: {
        required: 'Обязательное поле',
        numeric: 'Введите число',
        releaseDateRequired: 'Укажите дату выдачи',
      },
      toasts: {
        created: 'Груз создан',
        updated: 'Груз обновлён',
      },
    },
    import: {
      title: 'Импорт грузов',
      format: 'Формат',
      pickFiles: 'Выбрать файлы',
      process: 'Загрузить',
      processing: 'Обработка…',
      removeFile: 'Убрать файл',
      fileLabel: 'Файл {{index}}',
      buckets: {
        created: 'Создано',
        updated: 'Обновлено',
        warnings: 'Предупреждения',
        errors: 'Ошибки',
      },
      errors: {
        wrongExtension: 'Допустимы только файлы .xlsx и .xls',
        tooLarge: 'Файл превышает 50 МБ',
        nameTooLong: 'Слишком длинное имя файла',
        tooManyFiles: 'Не более {{max}} файлов за один импорт',
      },
      toasts: {
        processed: 'Импорт обработан',
      },
    },
    payment: {
      title: 'Оплата клиентом — {{article}}',
      statusLabel: 'Статус оплаты',
      noDocumentWarning: 'Прикрепите хотя бы один документ, чтобы сохранить статус.',
      save: 'Сохранить статус',
      toasts: {
        statusSaved: 'Статус оплаты сохранён',
      },
      docCounts: 'Отклонено: {{rejected}}, на проверке: {{pending}}, принято: {{accepted}}',
      rejectedMarker: 'Есть отклонённый документ',
      manager: {
        desiredStatusLabel: 'Желаемый статус',
        desiredStatusPlaceholder: 'Выберите статус…',
        options: {
          paid: 'Оплачено',
          partially_paid: 'Оплачено частично',
        },
        submit: 'Отправить на проверку',
        submitHint: 'Нужен хотя бы один документ и выбранный статус.',
        lockedHint:
          'Статус зафиксирован проверкой. Измените документы, чтобы открыть проверку заново.',
        toasts: {
          submitted: 'Отправлено на проверку',
        },
      },
      review: {
        decisionLabel: 'Решение',
        decision: {
          pending: 'Не проверен',
          accepted: 'Принять',
          rejected: 'Отклонить',
        },
        currencyLabel: 'Валюта',
        receivedRubLabel: 'Получено, ₽',
        foreignAmountLabel: 'Сумма в валюте',
        exchangeRateLabel: 'Курс',
        rubPreviewLabel: 'Расчёт, ₽',
        total: 'Итого принято: {{amount}}',
        save: 'Сохранить решения',
        invalidAmount: 'Введите сумму в формате 1234.56.',
        toasts: {
          saved: 'Решения сохранены',
        },
      },
      errors: {
        reviewNotOpen: 'Проверка для этого груза закрыта. Обновите страницу.',
        reviewIncomplete: 'Не все документы проверены.',
        documentLocked: 'Этот документ уже зафиксирован и не может быть изменён.',
        documentUnknown: 'Документ не найден. Обновите страницу.',
        noActiveDocument: 'Нет активных документов для проверки.',
      },
      documents: {
        title: 'Платёжные документы',
        empty: 'Документов пока нет',
        error: 'Не удалось загрузить документы',
        download: 'Скачать',
        upload: 'Прикрепить документ',
        uploading: 'Загрузка…',
        uploaderDeleted: 'Пользователь удалён',
        reviewStatus: {
          pending: 'Не проверен',
          accepted: 'Принят',
          rejected: 'Отклонён',
        },
        confirmDelete: {
          title: 'Удалить документ',
          text: 'Удалить документ «{{name}}»?',
        },
        toasts: {
          uploaded: 'Документ прикреплён',
          deleted: 'Документ удалён',
        },
        errors: {
          wrongType: 'Недопустимый тип файла',
          tooLarge: 'Файл превышает 25 МБ',
          nameTooLong: 'Слишком длинное имя файла',
        },
      },
    },
    summary: {
      error: 'Не удалось загрузить итоги',
    },
    totals: {
      count: 'Количество',
      totalWeightKg: 'Вес, кг',
      totalVolumeM3: 'Объём, м³',
      totalPrr: 'ПРР',
      totalTat: 'Оплата ТАТ',
      totalChinaPayment: 'Получение груза, Китай',
      totalChinaWarehouseAmount: 'Итого склад, Китай',
    },
    indicators: {
      paidNotIssued: 'Оплачены, не выданы',
      missingResponsibleManager: 'Без менеджера',
      missingPathFormat: 'Без дороги',
      noInsurance: 'Без страховки',
      rejectedDocument: 'Отклонённый документ',
      copy: 'Скопировать артикулы',
    },
    statistics: {
      toggle: 'Статистика',
      loading: 'Загрузка статистики…',
      error: 'Не удалось загрузить статистику',
      noData: 'Нет данных',
      clientPaymentStatus: {
        not_paid: 'Не оплачено',
        partially_paid: 'Оплачено частично',
        paid: 'Оплачено полностью',
        under_review: 'На проверке',
      },
      kpi: {
        count: 'Всего грузов',
        inTransit: 'В пути',
        arrivedNotIssued: 'Прибыли, не выданы',
        issued: 'Выданы',
        withoutManager: 'Без менеджера',
        weight: 'Общий вес, кг',
        volume: 'Общий объём, м³',
        chinaAmount: 'Сумма по Китаю',
        avgDaysInTransit: 'Среднее в пути, дней',
      },
      delta: {
        increased: 'рост на {{percent}}%',
        decreased: 'снижение на {{percent}}%',
        flat: 'без изменений',
      },
      sections: {
        lifecycle: 'Этапы',
        indicators: 'Показатели',
        totals: 'Итоги',
        payments: 'Оплаты',
        carriers: 'Перевозчики',
        managers: 'Менеджеры',
        monthly: 'Динамика по месяцам',
        distribution: 'Распределение',
        money: 'Суммы по месяцам',
        ratings: 'Рейтинги',
        routes: 'Маршруты',
      },
      lifecycle: {
        total: 'Всего',
        inTransit: 'В пути',
        arrivedNotIssued: 'Прибыли, не выданы',
        issued: 'Выданы',
        withoutManager: 'Без менеджера',
      },
      payments: {
        client: 'Оплата клиентом',
        carrier: 'Оплата перевозчику',
      },
      carriers: {
        carrier: 'Перевозчик',
        count: 'Количество',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
      },
      managers: {
        manager: 'Менеджер',
        unassigned: 'Без менеджера',
        count: 'Количество',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
        inTransit: 'В пути',
        arrivedNotIssued: 'Прибыли, не выданы',
        issued: 'Выданы',
      },
      monthly: {
        month: 'Месяц',
        count: 'Количество',
      },
      pies: {
        clientPayments: 'Оплаты клиентов',
        carriers: 'Перевозчики',
        lifecycle: 'Этапы',
        other: 'Прочие',
        status: 'Статус',
        stage: 'Этап',
        count: 'Количество',
        empty: 'Нет данных',
      },
      money: {
        title: 'Сумма по Китаю, ¥',
        month: 'Месяц',
        aria: 'Суммы по Китаю по месяцам',
      },
      ratings: {
        managers: 'Топ менеджеров',
        carriers: 'Топ перевозчиков',
        avgDaysInTransit: 'Среднее в пути, дней',
        count: 'Количество',
      },
      routes: {
        route: 'Маршрут',
        none: 'Без маршрута',
        count: 'Количество',
        countAria: 'Грузы по маршрутам',
        share: 'Доли маршрутов',
      },
      presets: {
        thisMonth: 'Этот месяц',
        last30: 'Последние 30 дней',
        quarter: 'Квартал',
        ytd: 'С начала года',
      },
    },
    columns: {
      article: 'Артикул',
      totalCost: 'Итоговая стоимость перевозки',
      daysWithoutPayment: 'Дни без опл',
      manager: 'Менеджер',
      carrier: 'Перевозчик',
      pathFormat: 'Дорога',
      status: 'Статус',
      nameGoods: 'Товар',
      numberOfSeats: 'Кол-мест',
      weight: 'Вес, кг',
      volume: 'Объём, м³',
      density: 'Плотность, кг/м³',
      transportationTariff: 'Тариф',
      transportationTariffForClients: 'Тариф перевозки клиенту',
      costGoods: 'Цена товара',
      insuranceCost: 'Цена страховки',
      packagingCost: 'Цена упаковки',
      timeFromChina: 'Дата отправки с Китая',
      chinaPayment: 'Получение груза, Китай',
      chinaWarehouseDispatch: 'Отправка со склада, Китай',
      chinaWarehouseInspection: 'Проверка на складе, Китай',
      chinaWarehousePackaging: 'Упаковка на складе, Китай',
      chinaWarehouseTotal: 'Итого, Китай',
      addressTransportationCost: 'Адресная доставка',
      prr: 'ПРР',
      tatCost: 'Оплата ТАТ',
      clientPaymentStatus: 'Оплачено клиентом',
      carrierPaymentStatus: 'Оплачено перевозчику',
      timeCargoArrivalToRf: 'Дата прибытия груза в РФ',
      timeCargoRelease: 'Дата выдачи груза',
      daysOnTheWay: 'Кол-во дней в пути',
      delete: 'Удаление',
    },
  },
  russiaRequests: {
    title: 'Заявки Россия',
    empty: 'Заявок пока нет',
    loading: 'Загрузка…',
    error: 'Не удалось загрузить заявки',
    actions: {
      newSimple: 'Простая',
      newComplex: 'Сложная',
      duplicate: 'Дублировать',
      send: 'Отправить',
      return: 'Вернуть',
      process: 'В обработку',
      reopen: 'Переоткрыть',
      close: 'Закрыть',
      success: 'Успешно',
      refuse: 'Отказ',
      postpone: 'Отложить',
      archive: 'В архив',
      unarchive: 'Из архива',
    },
    list: {
      searchPlaceholder: 'Поиск по названию или ID',
      loadMore: 'Загрузить ещё',
      loadingMore: 'Загрузка…',
    },
    filters: {
      status: 'Статус',
      type: 'Тип',
      manager: 'Менеджер',
      all: 'Все',
    },
    columns: {
      id: 'ID',
      type: 'Тип',
      status: 'Статус',
      name: 'Наименование',
      manager: 'Менеджер',
      startCities: 'Города отправления',
      endAddress: 'Адрес доставки',
      primaryBidSummary: 'Основная ставка',
      primaryBidEmpty: '—',
      primaryBidAwaiting: 'Ожидание ставок',
      primaryBidDays: '{{count}} дн.',
      primaryBidDaysRange: '{{min}}–{{max}} дн.',
      createdAt: 'Создано',
    },
    startCities: {
      empty: '—',
      more: '+{{count}}',
    },
    types: {
      lead: 'Лид',
      warehouse: 'Со склада',
      inTransit: 'В пути',
      urgent: 'Срочно',
    },
    editor: {
      title: 'Новая заявка по РФ',
      editTitle: 'Редактирование заявки',
      cancel: 'Отмена',
      save: 'Создать',
      saving: 'Создаём…',
      editSave: 'Сохранить',
      editSaving: 'Сохраняем…',
      submitError: 'Не удалось создать заявку. Проверьте поля и повторите попытку.',
      cards: {
        basics: 'Основное',
        endAddress: 'Адрес доставки',
        startCities: 'Города отправления',
      },
      fields: {
        type: 'Тип',
        name: 'Наименование',
        endAddress: 'Адрес доставки',
        startCities: 'Города отправления',
      },
      errors: {
        nameRequired: 'Введите наименование',
        endAddressRequired: 'Введите адрес доставки',
      },
      autosave: {
        saving: 'Сохраняем…',
        savedAt: 'Сохранено в {{time}}',
        error: 'Не удалось сохранить черновик',
      },
      startCities: {
        empty: 'Города отправления не выбраны',
        pickerPlaceholder: 'Выберите город…',
        add: 'Добавить',
        remove: 'Убрать {{name}}',
      },
      positions: {
        title: 'Позиции',
        empty: 'Позиций пока нет',
        add: 'Добавить позицию',
        newPosition: 'Новая позиция',
        fields: {
          name: 'Наименование',
          brand: 'Бренд',
          material: 'Материал',
          description: 'Описание',
          weightKg: 'Вес, кг',
          volumeM3: 'Объём, м³',
          quantity: 'Мест',
          productQuantity: 'Кол-во товара',
          photos: 'Фото',
        },
      },
      totals: {
        title: 'Вес и габариты',
        weight: 'Вес, кг',
        volume: 'Объём, м³',
      },
      files: {
        title: 'Файлы',
        add: 'Добавить файл',
        uploading: 'Загрузка…',
        usage: 'Файлов: {{count}} из {{max}}',
        capReached: 'Достигнут лимит файлов для заявки.',
        empty: 'Файлы ещё не прикреплены',
        download: 'Скачать',
        remove: 'Удалить',
        errors: {
          wrongType: 'Этот тип файла не поддерживается',
          tooLarge: 'Файл слишком большой',
          uploadFailed: 'Не удалось загрузить — попробуйте снова',
          listFailed: 'Не удалось загрузить список файлов',
          removeFailed: 'Не удалось удалить файл',
        },
      },
    },
    drawer: {
      close: 'Закрыть',
      editDraft: 'Дозаполнить',
      unavailable: {
        title: 'Заявка недоступна',
      },
      tabsComingSoon: 'Эта вкладка появится в следующем срезе #706.',
      parentLink: '← Китай #{{id}}',
      transitionError: 'Не удалось изменить статус. Попробуйте ещё раз.',
      sendReadiness: {
        title: 'Заявка не готова к отправке',
        missingEndAddress: 'Укажите адрес доставки.',
        missingTotals: 'Укажите общий вес и объём груза.',
        missingItems: 'Добавьте хотя бы одну позицию с наименованием, описанием, весом и объёмом.',
      },
      returnBanner: {
        title: 'Возвращена на доработку',
        body: 'Нужно действие: проверьте и отправьте снова.',
      },
      confirm: {
        close: {
          title: 'Закрыть заявку?',
          text: 'Закрытие финализирует заявку. Отмена возможна только повторным открытием администратором.',
        },
        archive: {
          title: 'Отправить в архив?',
          text: 'Архивация скроет заявку из списка по умолчанию. Позже можно достать обратно.',
        },
        success: {
          title: 'Завершить успешно?',
          text: 'Заявка будет помечена как успешная по выбранной ставке-победителю. Выберите победителя во вкладке перевозчиков, прежде чем завершать.',
        },
        refuse: {
          title: 'Оформить отказ?',
          text: 'Заявка будет закрыта как отказ клиента. Подробную причину можно будет указать позже.',
        },
      },
      reason: {
        return: {
          title: 'Вернуть в черновик',
          text: 'Кратко укажите причину — что нужно доработать.',
        },
        reopen: {
          title: 'Переоткрыть заявку',
          text: 'Кратко укажите причину — что нужно доработать после обработки.',
        },
      },
      info: {
        managerId: 'Менеджер (ID)',
      },
      header: {
        createdAt: 'Создано {{date}}',
        emptyAddress: '—',
      },
      tabs: {
        cargo: 'Груз',
        cost: 'Стоимость',
        chat: 'Чат',
      },
      cargo: {
        section: {
          body: 'Груз',
        },
        totals: {
          weightKg: 'Общий вес, кг',
          volumeM3: 'Общий объём, м³',
          quantity: 'Общее кол-во мест',
        },
        files: {
          empty: 'Нет файлов',
          error: 'Не удалось загрузить файлы',
          columns: {
            name: 'Имя',
            size: 'Размер',
          },
        },
      },
      cost: {
        readonly: {
          empty: 'Стоимость пока не указана',
          price: 'Стоимость',
          validityDays: 'Действует, дней',
          expiresAt: 'Истекает',
          expired: 'истёк',
        },
      },
      items: {
        empty: 'Нет товаров',
        columns: {
          name: 'Наименование',
          description: 'Описание',
          brand: 'Бренд',
          material: 'Материал',
          productQuantity: 'Кол-во товара',
          quantity: 'Кол-во мест',
          weightKg: 'Вес, кг',
          volumeM3: 'Объём, м³',
          photos: 'Фото',
        },
      },
      boxes: {
        empty: 'Нет мест',
        columns: {
          count: 'Кол-во',
          weightKg: 'Вес, кг',
          volumeM3: 'Объём, м³',
        },
      },
      audit: {
        empty: 'Нет записей в журнале',
        error: 'Не удалось загрузить журнал',
        columns: {
          at: 'Когда',
          action: 'Действие',
          actor: 'Кто',
          transition: 'Переход',
        },
        actions: {
          CREATE: 'Создание',
          UPDATE: 'Изменение',
          DELETE: 'Удаление',
          TRANSITION_SEND: 'Отправлено логисту',
          TRANSITION_AUTO_START: 'Автоматически в работе',
          TRANSITION_RETURN: 'Возвращено менеджеру',
          TRANSITION_PROCESS: 'Обработано',
          TRANSITION_REOPEN: 'Переоткрыто',
          TRANSITION_CLOSE: 'Закрыто',
          TRANSITION_SUCCESS: 'Успешно завершено',
          TRANSITION_REFUSE: 'Отказ клиента',
          TRANSITION_POSTPONE: 'Заявка отложена',
          WINNER_PICK: 'Выбран победитель',
          TRANSITION_ARCHIVE: 'В архив',
          TRANSITION_UNARCHIVE: 'Из архива',
          CHAT_POSTED: 'Сообщение в чате',
          CHAT_MARKED_UNREAD: 'Чат отмечен как непрочитанный',
          CHAT_UNMARKED: 'Снята отметка о непрочитанном',
        },
      },
      carriers: {
        empty: 'Перевозчики ещё не назначены',
        error: 'Не удалось загрузить перевозчиков',
        unitSuffix: {
          total: '',
          kg: '/кг',
          m3: '/м³',
          piece: '/шт.',
        },
        states: {
          PENDING: 'Ожидает ответа',
          ANSWERED: 'Ответил',
          REJECTED: 'Отклонён',
        },
        add: {
          modalTitle: 'Добавить перевозчика',
          trigger: 'Добавить перевозчика',
          submit: 'Добавить',
          modeInline: 'Ввести нового',
          modeFromCatalog: 'Выбрать из каталога',
          nameLabel: 'Название перевозчика',
          contactsLabel: 'Контакты',
          catalogPlaceholder: 'Выберите перевозчика из каталога…',
          catalogError: 'Не удалось загрузить каталог перевозчиков',
          notFound: 'Перевозчик не найден или деактивирован',
          invalidStatus: 'Добавление доступно только в статусе «В работе»',
          generic: 'Не удалось добавить перевозчика',
        },
        bid: {
          priceLabel: 'Цена',
          validityDaysLabel: 'Срок действия, дней',
          commentLabel: 'Комментарий',
          submit: 'Сохранить ставку',
          invalidStatus: 'Ставку можно добавить только в статусе «В работе»',
          notFound: 'Перевозчик не найден',
          generic: 'Не удалось сохранить ставку',
        },
        bidModal: {
          titlePrimary: 'Ставка · {{name}}',
        },
        actions: {
          editCarrier: 'Редактировать',
          deleteCarrier: 'Удалить',
          editBid: 'Редактировать ставку',
          deleteBid: 'Удалить ставку',
          menuAria: 'Действия',
        },
        editCarrier: {
          title: 'Редактирование перевозчика {{code}}',
          submit: 'Сохранить',
          invalidStatus: 'Редактирование доступно только в статусе «В работе»',
          notFound: 'Перевозчик не найден',
          generic: 'Не удалось сохранить изменения',
        },
        editBid: {
          title: 'Редактирование ставки',
        },
        deleteCarrier: {
          confirmTitle: 'Удалить вариант {{code}}?',
          confirmBody: 'Будут удалены все ставки по этому перевозчику. Действие необратимо.',
        },
        deleteBid: {
          confirmTitle: 'Удалить ставку?',
          confirmBody: 'Действие необратимо.',
        },
        card: {
          addPrimary: 'Добавить ставку',
          addedAt: 'Добавлен {{date}}',
          contactsHeading: 'Контакты',
          daysLeft: 'осталось {{days}} дн.',
          expiresToday: 'Истекает сегодня',
          expired: 'Истекла',
        },
        section: {
          bestOffers: 'Перевозчики',
          completedCount: 'Ответили {{completed}} из {{total}}',
        },
        winner: {
          pick: 'Выбрать победителем',
          badge: 'Победитель',
        },
        perCity: {
          heading: 'Ставки по городам отправления',
          noRate: 'Ставки пока нет',
          addRate: 'Добавить ставку · {{carrier}}',
          editRate: 'Изменить',
        },
      },
    },
    chat: {
      empty: 'Сообщений ещё нет',
      placeholder: 'Ответить как {{name}}…',
      send: 'Отправить',
      newDivider: 'Новые',
      markUnread: 'Отметить непрочитанным',
      unmarkUnread: 'Снять отметку',
      aria: {
        sent: 'Отправлено',
        read: 'Прочитано',
      },
    },
  },
  commercialProposals: {
    title: 'Коммерческие предложения',
    empty: 'КП пока нет',
    loading: 'Загрузка…',
    error: 'Не удалось загрузить КП',
    actions: {
      create: 'Новое КП',
      edit: 'Редактировать',
      preview: 'Превью',
      publish: 'Опубликовать',
      publishing: 'Публикуем…',
      revoke: 'Снять с публикации',
      revoking: 'Снимаем…',
      copyLink: 'Скопировать ссылку',
      copyLinkDone: 'Ссылка скопирована',
      copyLinkError: 'Не удалось скопировать ссылку',
      downloadPdf: 'Скачать PDF',
      downloadError: 'Не удалось скачать PDF',
    },
    columns: {
      publicCode: 'Код',
      client: 'Клиент',
      productName: 'Товар',
      status: 'Статус',
      owner: 'Владелец',
      htmlViews: 'Просмотры',
      updatedAt: 'Обновлено',
    },
    status: {
      draft: 'Черновик',
      published: 'Опубликовано',
    },
    editor: {
      title: 'Новое КП',
      editTitle: 'Редактирование КП',
      cancel: 'Отмена',
      create: 'Создать черновик',
      creating: 'Создаём…',
      createError: 'Не удалось создать КП. Проверьте поля и повторите попытку.',
      save: 'Сохранить',
      saving: 'Сохраняем…',
      saveError: 'Не удалось сохранить КП. Проверьте поля и повторите попытку.',
      publishedLocked:
        'Опубликованное КП доступно только для чтения. Чтобы изменить, сначала снимите его с публикации.',
      characteristicsHint: 'Каждая характеристика с новой строки',
      groups: {
        header: 'Шапка и курсы',
        product: 'Товар',
        buyout: 'Выкуп товара',
        logistics: 'Логистика',
        totals: 'Итоги',
        advanced: 'Коэффициенты пересчёта',
        notes: 'Сноски',
        manager: 'Менеджер',
      },
      fields: {
        mode: 'Состав КП',
        client: 'Кому / клиент',
        productName: 'Название товара',
        proposalDate: 'Дата',
        cnyRateRub: 'Курс ¥ (₽ за 1 юань)',
        usdRateRub: 'Курс $ (₽ за 1 доллар)',
        buyoutTotalCurrency: 'Валюта итога выкупа',
        logisticsTotalCurrency: 'Валюта итога логистики',
        grandTotalCurrency: 'Валюта общего итога',
        characteristics: 'Характеристики',
        buyoutTerm: 'Срок выкупа',
        goodsCny: 'Стоимость товара (¥)',
        chinaDeliveryCny: 'Доставка по Китаю (¥)',
        paymentScheme: 'Схема оплаты',
        destination: 'Пункт назначения',
        logisticsTerm: 'Срок логистики',
        places: 'Кол-во мест',
        weightKg: 'Вес (кг)',
        volumeM3: 'Объём (м³)',
        tariffUsd: 'Тариф ($)',
        tariffUnit: 'Единица тарифа',
        packagingUsd: 'Упаковка ($)',
        prrUsd: 'ПРР ($)',
        servicePercent: 'Услуги «под ключ» (%)',
        noVatDivisor: '% без НДС',
        vatDivisor: '% НДС',
        insurancePercent: 'Страховка (%)',
        insuranceCnyPerUsdRate: 'Курс ¥/$ для страховки',
        buyoutNotes: 'Сноски — выкуп',
        logisticsNotes: 'Сноски — логистика',
        managerName: 'Имя',
        managerPhone: 'Телефон',
        photo: 'Фото товара',
      },
      photo: {
        upload: 'Загрузить фото',
        replace: 'Заменить фото',
        clear: 'Удалить фото',
        uploading: 'Загрузка…',
        alt: 'Фото товара',
        fromClipboard: 'Добавить фото из буфера',
        errors: {
          tooLarge: 'Файл слишком большой. Максимум 10 МБ.',
          wrongType: 'Изображения SVG не поддерживаются.',
          decodeFailed: 'Браузер не смог декодировать формат изображения: {{format}}.',
          encodeFailed: 'Браузер не смог подготовить изображение к загрузке.',
          uploadFailed: 'Не удалось загрузить фото. Повторите попытку.',
          unsupported: 'Браузер не поддерживает чтение буфера обмена.',
          denied: 'Доступ к буферу обмена запрещён.',
          empty: 'В буфере нет подходящего изображения.',
          unsupportedType: 'Этот тип изображения не поддерживается.',
          failed: 'Не удалось получить изображение из буфера.',
        },
      },
      paymentScheme: {
        vat: 'Р/с с НДС + УПД',
        novat: 'Р/с без НДС + УПД',
        cash: 'Наличными',
        crypto: 'Криптовалюта',
        card: 'На карту',
      },
      mode: {
        both: 'Выкуп + Логистика',
        buyout: 'Выкуп',
        logistics: 'Логистика',
      },
      tariffUnit: { kg: 'за кг', m3: 'за м³' },
    },
    calc: {
      title: 'Расчёт',
      previewNote: 'Предварительный расчёт. Итоговые значения сохранит сервер.',
      backendNote: 'Расчёт сервера',
      unavailable: 'Расчёт недоступен — проверьте курсы и делители (должны быть больше нуля).',
      serviceCny: 'Услуги «под ключ»',
      totalCny: 'Итого в юанях',
      buyRub: 'Выкуп (₽)',
      transportUsd: 'Перевозка',
      insuranceUsd: 'Страховка',
      logisticsUsd: 'Логистика (всего)',
      logisticsRub: 'Логистика (₽)',
      grandTotal: 'Итого: выкуп + доставка',
      params: {
        title: 'Параметры расчёта',
        appliedMarkup: 'Применённый %',
        noMarkup: 'наценка не применяется',
      },
    },
    drawer: {
      loading: 'Загрузка…',
      error: 'Не удалось загрузить КП',
      ownerYou: 'Вы',
      previewTitle: 'Превью предложения',
      fields: {
        publicCode: 'Код',
        status: 'Статус',
        client: 'Клиент',
        productName: 'Товар',
        owner: 'Владелец',
        htmlViews: 'Просмотры страницы',
        pdfDownloads: 'Скачивания PDF',
        updatedAt: 'Обновлено',
        publishedAt: 'Опубликовано',
        photo: 'Фото товара',
      },
    },
  },
  commercialProposalsPublic: {
    title: 'Коммерческое предложение',
    loading: 'Загрузка…',
    notFound: {
      title: 'Страница недоступна',
      body: 'Ссылка недействительна или срок её действия истёк.',
    },
    characteristics: 'Характеристики',
    photoAlt: 'Фото товара',
    downloadPdf: 'Скачать PDF',
    downloadError: 'Не удалось скачать PDF. Повторите попытку.',
    fields: {
      proposalDate: 'Дата',
      client: 'Кому',
      cnyRate: 'Курс ¥',
      usdRate: 'Курс $',
    },
    totals: {
      buy: 'Выкуп',
      logistics: 'Логистика',
      grand: 'Итого',
    },
  },
  agent: {
    title: 'Агент',
    newConversation: 'Новый диалог',
    chat: {
      empty: 'Задайте вопрос агенту-аналитику, чтобы начать.',
      thinking: 'Думаю…',
    },
    history: {
      title: 'Диалоги',
      regionLabel: 'История диалогов агента',
      loading: 'Загрузка диалогов…',
      empty: 'Сохранённых диалогов пока нет.',
      untitled: 'Без названия',
      loadFailed: 'Не удалось загрузить историю диалогов',
      openFailed: 'Не удалось открыть диалог',
    },
    composer: {
      questionLabel: 'Вопрос',
      placeholder: 'Спросите про заявки, выручку, конверсию…',
      periodLabel: 'Период',
      periodAny: 'Любой период',
      periods: {
        today: 'Сегодня',
        last7d: 'Последние 7 дней',
        month: 'Текущий месяц',
        quarter: 'Квартал',
      },
      send: 'Отправить',
      errorRequired: 'Введите вопрос.',
      errorTooLong: 'Вопрос слишком длинный.',
    },
    progress: {
      running: 'выполняется',
      done: 'готово',
    },
    verdict: {
      showBasis: 'Показать выкладку',
      hideBasis: 'Скрыть выкладку',
      basisLabel: 'Источник',
      candidateLabel: 'Кандидат {{n}}',
      outcome: {
        agreed: 'Источники сходятся',
        reconciled: 'Согласовано',
        discrepancy: 'Источники расходятся',
      },
      confidence: {
        high: 'Высокая уверенность',
        low: 'Низкая уверенность',
      },
      source: {
        registry: 'Реестр метрик',
        sql: 'SQL-запрос',
      },
      task: 'Задача',
      taskId: 'ID задачи',
      figures: 'Показатели',
      noDataReasonLabel: 'Почему нет ответа',
      noDataReason: {
        unsupported_domain: 'Этот аналитический домен пока не поддерживается.',
        missing_schema: 'Для этого вопроса пока нет утверждённой схемы или метрики.',
        ambiguous_period: 'Запрошенный период неоднозначен.',
        unsafe_columns: 'Для запроса нужны колонки, не разрешённые агенту.',
        too_broad: 'Вопрос слишком широкий для одного безопасного запроса.',
        query_rejected: 'Сформированный SQL-запрос заблокирован правилами безопасности.',
        query_timeout: 'SQL-запрос к базе данных превысил лимит времени.',
        missing_figure: 'Запрос не вернул обязательный показатель.',
        non_numeric_figure: 'Обязательный показатель оказался не числом.',
        too_many_tasks: 'Запрос был разбит на слишком много задач.',
        too_many_rows: 'Запрос вернул слишком много строк для безопасного показа.',
      },
      metric: 'Метрика',
      sql: 'SQL',
      period: 'Период',
      filters: 'Фильтры',
      values: 'Значения',
    },
    artifacts: {
      title: 'Артефакты',
      regionLabel: 'Артефакты агента',
      empty: 'Здесь появятся артефакты, созданные агентом.',
      received: 'Артефакт получен',
      unsupported: 'Этот тип артефакта пока не поддерживается',
      pin: 'Закрепить',
      pinning: 'Закрепляем…',
      pinned: 'Артефакт закреплён в моих дашбордах.',
      pinFailed: 'Не удалось закрепить артефакт.',
      chart: {
        empty: 'Нет данных для графика',
        dataTable: 'Данные графика',
        category: 'Категория',
        noValue: '—',
        provenance: 'Источник',
        createdAt: 'Создано',
        tooltip: '{{series}} · {{x}}: {{y}}',
      },
    },
    savedDashboard: {
      title: 'Мои дашборды',
      regionLabel: 'Закреплённые артефакты',
      refresh: 'Обновить',
      retry: 'Повторить',
      loading: 'Загрузка дашбордов…',
      emptyTitle: 'Пока нет закреплённых артефактов',
      empty: 'Закрепите артефакты из ответа агента, чтобы собрать личный дашборд.',
      loadFailed: 'Не удалось загрузить мои дашборды',
      loadFailedText: 'Попробуйте обновить страницу.',
      moveUp: 'Выше',
      moveDown: 'Ниже',
      unpin: 'Убрать',
      unpinned: 'Артефакт убран из моих дашбордов.',
      unpinFailed: 'Не удалось убрать артефакт.',
      reorderFailed: 'Не удалось изменить порядок.',
    },
    error: {
      notConfigured: 'Агент-аналитик не настроен. Обратитесь к администратору.',
      sqlRejected: 'SQL-запрос к базе данных заблокирован правилами безопасности.',
      sqlTimeout: 'SQL-запрос к базе данных превысил лимит времени. Уточните вопрос.',
      runFailed: 'Модель не смогла ответить. Попробуйте ещё раз через несколько секунд.',
      generic: 'Не удалось выполнить запрос к агенту. Попробуйте ещё раз.',
    },
    admin: {
      title: 'Настройки агента',
      refresh: 'Обновить',
      loadFailed: 'Не удалось загрузить настройки агента',
      activePrompt: 'Активный prompt',
      glossaryCount: 'Термины',
      metricCount: 'Метрики',
      memoryState: 'Память',
      enabled: 'Включена',
      disabled: 'Выключена',
      catalogVersion: 'Каталог',
      promptDraft: 'Черновик бизнес-инструкции',
      promptPlaceholder: 'Описание бизнеса, роли агента и стиля ответа',
      savePromptDraft: 'Сохранить черновик',
      kindGlossary: 'Термин',
      kindMetric: 'Метрика',
      termPlaceholder: 'Название',
      definition: 'Определение',
      definitionPlaceholder: 'Что это значит для бизнеса',
      addDraft: 'Добавить черновик',
      prompts: 'Версии prompt',
      glossary: 'Глоссарий',
      memory: 'Память',
      memoryTitlePlaceholder: 'Что запомнить',
      memorySummary: 'Описание памяти',
      memorySummaryPlaceholder: 'Факт, правило или предпочтение для будущих ответов',
      addMemory: 'Добавить память',
      saveMemory: 'Сохранить память',
      edit: 'Изменить',
      cancel: 'Отмена',
      activate: 'Активировать',
      approve: 'Одобрить',
      reject: 'Отклонить',
      archive: 'Архив',
    },
  },
  dashboards: {
    chinaRequests: {
      title: 'Заявки Китай — сводка',
      periodLabel: 'Период',
      computedAt: 'обновлено {{time}}',
      error: 'Не удалось загрузить сводку',
      retry: 'Повторить',
      periods: {
        today: 'Сегодня',
        last7d: 'Последние 7 дней',
        month: 'Текущий месяц',
        quarter: 'Квартал',
        custom: 'Произвольный',
      },
      customFrom: 'С',
      customTo: 'По',
      customPrompt: 'Выберите начальную и конечную даты',
      kpi: {
        newRequests: 'Новые заявки',
        inWorkNow: 'В работе сейчас',
        success: 'Успешно',
        conversion: 'Конверсия',
        overdueNow: 'Просрочено сейчас',
        volume: 'Объём',
        container: 'Контейнер',
        nonContainer: 'Не контейнер',
        ppSuffix: ' п.п.',
      },
      delta: {
        increased: 'рост на {{value}}',
        decreased: 'снижение на {{value}}',
        flat: 'без изменений',
      },
      sla: {
        overdueNow: 'Просрочено',
        hotNow: 'Горит',
        avgProcessingDays: 'Ср. обработка, дн.',
        reopenCount: 'Возвраты в работу',
        activeScopeNote:
          'Учитываются только активные заявки в статусах «К работе» и «В работе». Обработанные заявки не считаются просроченными.',
      },
      funnel: {
        title: 'Воронка статусов',
        statusHeader: 'Статус',
        countHeader: 'Количество',
      },
      trend: {
        title: 'Создано и закрыто',
        legend: {
          created: 'Создано',
          closed: 'Закрыто',
          success: 'Успешно',
        },
        empty: 'Нет данных за выбранный период',
        error: 'Не удалось загрузить динамику',
      },
      managers: {
        name: 'Менеджер',
        created: 'Создано',
        inWorkNow: 'В работе',
        success: 'Успех',
        refused: 'Отказ',
        conversion: 'Конверсия',
        volume: 'Объём',
      },
      refusal: {
        title: 'Причины отказов',
        reasonHeader: 'Причина',
        countHeader: 'Количество',
      },
    },
  },
  clients: {
    title: 'Клиенты',
    emptyContacts: 'Нет активных контактов',
    emptyLegal: 'Нет юридических лиц',
    emptyVersions: 'История изменений пуста',
    noPrimaryContact: 'Основной контакт не указан',
    versionsCollapsed: 'История загружается при открытии.',
    actions: {
      create: 'Создать клиента',
      addContact: 'Добавить контакт',
      addLegal: 'Добавить юр. лицо',
      addRequisites: 'Добавить реквизиты',
      callContact: 'Позвонить: {{name}}',
      checkResult: 'Обновить и проверить',
      checkClientCreateResult: 'Обновить список и закрыть',
      createAnyway: 'Всё равно создать набор',
      collapseText: 'Свернуть',
      copyInnOf: 'Скопировать ИНН: {{name}}',
      copyPhoneOf: 'Скопировать телефон: {{name}}',
      copyRequisites: 'Копировать',
      copyRequisitesOf: 'Скопировать реквизиты «{{name}}» ({{entity}})',
      expandRequisitesOf: 'Показать реквизиты полностью: {{name}}',
      expandText: 'Показать полностью',
      setPrimary: 'Сделать основным',
      showArchive: 'Показать архив ({{count}})',
      hideArchive: 'Скрыть архив',
      showHistory: 'Показать историю',
      hideHistory: 'Скрыть историю',
      restoreVersion: 'Восстановить эту версию',
      viewVersion: 'Просмотр',
      viewVersionOf: 'Просмотреть версию #{{number}} клиента «{{name}}»',
      loadMore: 'Загрузить ещё',
    },
    badges: {
      primary: 'Основной',
    },
    blocked: {
      archivePrimaryContact:
        'Основной контакт нельзя архивировать: сначала назначьте основным другой контакт.',
      archiveLastContact: 'Это единственный активный контакт: сначала добавьте другой.',
      alreadyPrimary: 'Этот контакт уже основной.',
      pendingAction: 'Предыдущее действие с этой записью ещё выполняется.',
      pendingAncestor: 'Идёт другое изменение этого клиента — дождитесь результата.',
      archivedClient:
        'Клиент в архиве: изменения недоступны. Восстановите клиента, чтобы снова редактировать контакты, юр. лица и реквизиты.',
      archivedLegal:
        'Юр. лицо в архиве: реквизиты нельзя менять. Восстановите юр. лицо, чтобы продолжить.',
    },
    fields: {
      name: 'Название',
      comment: 'Комментарий',
      contactFullName: 'ФИО',
      contactComment: 'Комментарий к контакту',
      phone: 'Телефон',
      primaryContact: 'Основной контакт',
      legalEntities: 'Юр. лица',
      manager: 'Менеджер',
      status: 'Статус',
      inn: 'ИНН',
      legalType: 'Форма',
      legalName: 'Наименование юр. лица',
      requisites: 'Реквизиты',
      bankName: 'Банк',
      bik: 'БИК',
      account: 'Расчётный счёт',
      lifecycle: 'Этап',
      lengthCounter: '{{length}} из {{max}} символов',
    },
    hints: {
      innOoo: 'ИНН организации — 10 цифр.',
      innIp: 'ИНН индивидуального предпринимателя — 12 цифр.',
      legalTypeImmutable: 'Форму нельзя изменить после создания.',
      firstRequisites: 'Первый набор реквизитов юр. лица. Остальные добавляются в карточке.',
      requisitesDetails: 'Текст реквизитов копируется целиком, вместе с переносами строк.',
      optionalSlot: 'Необязательно. Пустое поле означает «не указано».',
      phoneFormat: 'Международный формат, например +79991234567.',
    },
    filters: {
      toggle: 'Фильтры',
      reset: 'Сбросить фильтры',
      search: {
        label: 'Поиск',
        placeholder: 'Имя, телефон или ИНН',
        truncated: 'Запрос сокращён до {{max}} символов.',
      },
      archive: {
        label: 'Архив',
        active: 'Активные',
        archived: 'Архивные',
        all: 'Все',
      },
      manager: {
        label: 'Менеджер',
        any: 'Все менеджеры',
        invalid: 'Менеджер из ссылки не распознан, список не отфильтрован по менеджеру.',
      },
    },
    list: {
      loadedCount: 'Загружено: {{count}}',
      refreshing: 'обновление…',
      anchorLost: 'Не удалось вернуться к открытой ранее строке: её нет в текущем списке.',
      appendFailed: 'Не удалось загрузить следующую страницу. Загруженные строки сохранены.',
      refreshFailed: 'Не удалось обновить список. Показаны строки, загруженные ранее.',
      stale: 'Ниже — предыдущий результат, идёт обновление…',
    },
    detail: {
      refreshFailed:
        'Не удалось обновить карточку. Показаны данные, загруженные ранее; введённое в открытых формах сохранено.',
    },
    empty: {
      noResultsTitle: 'Ничего не найдено',
      noResultsText: 'Измените запрос или сбросьте фильтры.',
      archiveTitle: 'Архив пуст',
      archiveText: 'Архивных клиентов нет.',
      firstUseTitle: 'Клиентов пока нет',
      firstUseText: 'Создайте первого клиента, чтобы начать работу.',
    },
    copy: {
      success: 'Скопировано',
      failed: 'Не удалось скопировать. Текст можно выделить вручную.',
      fallbackTitle: 'Копирование недоступно',
      fallbackLabel: 'Текст для копирования',
    },
    requisites: {
      setOrdinal: 'Реквизиты №{{n}}',
      lastActiveHint: 'Это единственный активный набор реквизитов — его нельзя архивировать.',
      inspectTitle: 'Текущие наборы реквизитов юр. лица «{{entity}}»',
      inspectHelp:
        'Это состояние на сервере после обновления. Если вашего набора в списке нет — сохраните ещё раз; если есть — закройте редактор.',
      inspectEmpty: 'У этого юр. лица нет наборов реквизитов.',
    },
    restore: {
      summary:
        'При восстановлении версии будет изменено записей: {{changed}}, архивировано: {{archived}}, возвращено из архива: {{restored}}, создано заново: {{recreated}}.',
      renamedTo: '→ станет «{{name}}»',
      changedTitle: 'Будет изменено',
      archivedTitle: 'Будет архивировано',
      restoredTitle: 'Будет возвращено из архива',
      recreatedTitle: 'Будет создано заново',
      rootTitle: 'Поля клиента',
      rootName: 'Название',
      rootComment: 'Комментарий',
      rootArchive: 'Сам клиент будет архивирован',
      rootUnarchive: 'Сам клиент будет возвращён из архива',
      noChanges: 'Сохранённое состояние совпадает с текущим — ничего не изменится.',
      managerKept: 'Владелец записи и менеджер клиента остаются прежними.',
      banksNotRecorded:
        'В снимке сохранён только текст реквизитов — банк, БИК, счёт и история наборов не восстанавливаются.',
      missingLegal: 'Сервер откажет в восстановлении: юр. лиц из версии больше нет ({{names}}).',
      contactLabel: 'Контакт «{{name}}»',
      legalLabel: 'Юр. лицо «{{name}}»',
      pending: 'Восстановление выполняется — не закрывайте окно.',
      impactUnavailable:
        'Текущее состояние клиента не загружено, поэтому список изменений показать нельзя. Ниже — только сохранённая версия.',
    },
    conflict: {
      nameTaken: 'Клиент с таким названием уже существует. Измените название.',
      phoneTaken: 'Этот телефон уже занят другой записью. Проверьте номер.',
      innTaken: 'Юр. лицо с таким ИНН уже существует. Проверьте ИНН.',
      clientArchived: 'Клиент в архиве. Восстановите его, чтобы вносить изменения.',
      legalArchived: 'Юр. лицо в архиве. Восстановите его, чтобы вносить изменения.',
      requisitesArchived: 'Набор реквизитов в архиве. Восстановите его, чтобы вносить изменения.',
      restoreAmbiguous:
        'Версию нельзя восстановить: непонятно, к каким банковским реквизитам она относится.',
      restoreAmbiguousDetail:
        'Версию нельзя восстановить: непонятно, к каким банковским реквизитам она относится. Изменения не применялись. Проверьте юр. лица ({{count}}) вручную.',
      uncertainOutcome:
        'Ответ сервера не получен — запись могла быть сохранена. Не отправляйте повторно: обновите данные и проверьте результат.',
      uncertainInspected:
        'Результат первой попытки по-прежнему неизвестен. Сверьтесь со списком ниже: сохраняйте повторно, только если вашего набора там нет.',
      noVerdictRetry:
        'Ответ сервера не получен. Ничего не потеряно — попробуйте сохранить ещё раз.',
      refreshFailed:
        'Не удалось обновить данные. Введённое сохранено — попробуйте проверить ещё раз.',
    },
    legalType: {
      OOO: 'ООО',
      IP: 'ИП',
    },
    modals: {
      createTitle: 'Новый клиент',
      editTitle: 'Редактировать клиента',
      addContactTitle: 'Добавить контакт: {{client}}',
      editContactTitle: 'Редактировать контакт: {{client}}',
      addLegalTitle: 'Добавить юр. лицо: {{client}}',
      editLegalTitle: 'Редактировать юр. лицо: {{client}}',
      addRequisitesTitle: 'Добавить реквизиты: {{entity}}',
      editRequisitesTitle: 'Редактировать реквизиты: {{entity}}',
      versionTitle: 'Версия #{{number}}',
    },
    sections: {
      summary: 'Кратко',
      firstContact: 'Первый контакт',
      contacts: 'Контакты',
      legalEntities: 'Юридические лица',
      versions: 'История изменений',
    },
    confirm: {
      archiveTitle: 'Архивировать клиента?',
      archiveMessage:
        'Клиент «{{name}}» будет переведён в архив. Дочерние изменения будут заблокированы до восстановления.',
      restoreTitle: 'Восстановить клиента?',
      restoreMessage: 'Клиент «{{name}}» снова станет доступным для изменений.',
      archiveContactTitle: 'Архивировать контакт?',
      archiveContactMessage: 'Контакт «{{name}}» будет перемещён в архив.',
      primaryContactTitle: 'Сделать контакт основным?',
      primaryContactMessage: 'Основным контактом клиента станет «{{name}}».',
      archiveLegalTitle: 'Архивировать юр. лицо?',
      archiveLegalMessage:
        'Юр. лицо «{{name}}» и его реквизиты будут перемещены в архив и станут недоступны для изменений.',
      archiveRequisitesTitle: 'Архивировать реквизиты?',
      archiveRequisitesMessage:
        'Набор реквизитов «{{name}}» юр. лица «{{entity}}» будет перемещён в архив. Текст останется доступным для чтения.',
      createAnywayTitle: 'Создать ещё один набор?',
      createAnywayMessage:
        'Результат первой попытки неизвестен. Если тот набор уже сохранён, у юр. лица появится второй такой же — удалить его сможет только менеджер вручную.',
      restoreVersionTitle: 'Восстановить версию?',
      restoreVersionMessage:
        'Данные клиента «{{name}}» будут заменены версией #{{number}}. Текущее состояние сохранится в истории.',
    },
    errors: {
      invalidPhone: 'Введите номер в международном формате, например +79991234567',
      required: 'Заполните поле — одних пробелов недостаточно.',
      tooLong: 'Слишком длинный текст: не больше {{max}} символов.',
      tooLongUnbounded: 'Слишком длинный текст.',
      innOoo: 'ИНН организации — 10 цифр с корректной контрольной суммой.',
      innIp: 'ИНН индивидуального предпринимателя — 12 цифр с корректной контрольной суммой.',
      innAny: 'Введите корректный ИНН: 10 цифр для организации, 12 — для ИП.',
    },
    identifierTaken: {
      title: 'Этот контакт уже используется',
      body: 'Указанный контакт уже занят другой записью. Проверьте данные или используйте другой контакт.',
      bodyOwned:
        'Этот контакт уже принадлежит существующему клиенту. Откройте его карточку, чтобы продолжить.',
      openClient: 'Открыть клиента',
    },
    toasts: {
      created: 'Клиент создан',
      saved: 'Изменения сохранены',
      archived: 'Клиент архивирован',
      restored: 'Клиент восстановлен',
      contactAdded: 'Контакт добавлен',
      contactSaved: 'Контакт обновлён',
      contactArchived: 'Контакт архивирован',
      contactRestored: 'Контакт восстановлен',
      contactPrimary: 'Основной контакт изменён',
      legalAdded: 'Юр. лицо добавлено',
      legalSaved: 'Юр. лицо обновлено',
      legalArchived: 'Юр. лицо архивировано',
      legalRestored: 'Юр. лицо восстановлено',
      requisitesAdded: 'Реквизиты добавлены',
      requisitesSaved: 'Реквизиты обновлены',
      requisitesArchived: 'Реквизиты архивированы',
      requisitesRestored: 'Реквизиты восстановлены',
      versionRestored: 'Версия восстановлена',
    },
    versionAction: {
      create: 'Создание клиента',
      update: 'Изменение клиента',
      archive: 'Архивирование клиента',
      restore: 'Восстановление клиента',
      versionRestore: 'Восстановление из версии',
      contactAdd: 'Добавлен контакт',
      contactUpdate: 'Изменён контакт',
      contactArchive: 'Архивирован контакт',
      contactRestore: 'Восстановлен контакт',
      contactPrimary: 'Назначен основной контакт',
      legalAdd: 'Добавлено юр. лицо',
      legalUpdate: 'Изменено юр. лицо',
      legalArchive: 'Архивировано юр. лицо',
      legalRestore: 'Восстановлено юр. лицо',
      lifecycleWorking: 'Отмечен как рабочий клиент',
    },
    lifecycle: {
      potential: 'Потенциальный',
      working: 'Действующий',
    },
  },
  carriers: {
    actions: {
      addPriceList: 'Добавить прайс',
      addWarehouse: 'Добавить склад',
      attachFile: 'Прикрепить файл',
      create: 'Добавить перевозчика',
      open: 'Открыть',
      preview: 'Просмотр',
      replaceFile: 'Заменить файл',
      uploading: 'Загрузка…',
    },
    columns: {
      contacts: 'Контакты',
      name: 'Название',
      notes: 'Комментарий',
      priceLists: 'Прайсы',
      status: 'Статус',
      warehouses: 'Склады',
    },
    empty: 'Перевозчики не найдены',
    errors: {
      imageType: 'Загрузите PDF, JPG, PNG или WEBP',
    },
    fields: {
      city: 'Город',
      description: 'Описание',
      email: 'Email',
      file: 'Файл',
      name: 'Название',
      noFile: 'Файл не выбран',
      notes: 'Комментарий',
      optional: 'Опционально',
      phone: 'Телефон',
      priceListName: 'Название прайса',
      warehouseName: 'Название склада',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      inactive: 'Неактивные',
    },
    modals: {
      createTitle: 'Новый перевозчик',
      editTitle: 'Перевозчик — {{name}}',
    },
    search: 'Поиск',
    sections: {
      priceLists: 'Прайсы',
      warehouses: 'Склады',
    },
    status: {
      active: 'Активен',
      inactive: 'Неактивен',
    },
    title: 'Перевозчики',
    toasts: {
      activated: 'Перевозчик активирован',
      created: 'Перевозчик создан',
      deactivated: 'Перевозчик деактивирован',
      fileUploaded: 'Файл загружен',
      priceListCreated: 'Прайс добавлен',
      priceListDeleted: 'Прайс удалён',
      priceListUpdated: 'Прайс обновлён',
      updated: 'Перевозчик обновлён',
      warehouseCreated: 'Склад добавлен',
      warehouseDeleted: 'Склад удалён',
      warehouseUpdated: 'Склад обновлён',
    },
  },
  arrivalCities: {
    actions: {
      create: 'Добавить город',
    },
    badges: {
      default: 'По умолчанию',
    },
    columns: {
      default: 'По умолчанию',
      name: 'Название',
      shortName: 'Сокр.',
      status: 'Статус',
    },
    empty: 'Города прибытия не найдены',
    errors: {
      shortNameRegex: 'Сокращение: 1-3 кириллических или латинских символов либо цифр',
    },
    fields: {
      isDefault: 'Город прибытия по умолчанию',
      name: 'Название',
      shortName: 'Сокращение',
      shortNameHelp: 'До 3 символов: кириллица, латиница или цифры',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      inactive: 'Архив',
    },
    modals: {
      createTitle: 'Новый город прибытия',
      editTitle: 'Город прибытия — {{name}}',
    },
    search: 'Поиск',
    status: {
      active: 'Активен',
      inactive: 'В архиве',
    },
    title: 'Города прибытия',
    toasts: {
      activated: 'Город восстановлен',
      archived: 'Город архивирован',
      created: 'Город создан',
      updated: 'Город обновлён',
    },
  },
  roadOptions: {
    actions: {
      create: 'Добавить дорогу',
    },
    columns: {
      createdAt: 'Создано',
      name: 'Название',
      sortOrder: 'Порядок',
      status: 'Статус',
    },
    empty: 'Дороги не найдены',
    errors: {
      sortOrderInvalid: 'Порядок: целое число ≥ 0',
    },
    fields: {
      name: 'Название',
      sortOrder: 'Порядок сортировки',
      sortOrderHelp: 'Целое число ≥ 0; меньше — выше в списке',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      inactive: 'Архив',
    },
    hints: {
      archivedRow: 'Запись в архиве — будет недоступна в новых заявках',
    },
    modals: {
      createTitle: 'Новая дорога',
      editTitle: 'Дорога — {{name}}',
    },
    search: 'Поиск',
    status: {
      active: 'Активна',
      inactive: 'В архиве',
    },
    title: 'Дороги',
    toasts: {
      activated: 'Дорога восстановлена',
      archived: 'Дорога архивирована',
      created: 'Дорога создана',
      updated: 'Дорога обновлена',
    },
  },
  packagingOptions: {
    actions: {
      create: 'Добавить упаковку',
    },
    columns: {
      createdAt: 'Создано',
      name: 'Название',
      sortOrder: 'Порядок',
      status: 'Статус',
    },
    empty: 'Упаковка не найдена',
    errors: {
      sortOrderInvalid: 'Порядок: целое число ≥ 0',
    },
    fields: {
      name: 'Название',
      sortOrder: 'Порядок сортировки',
      sortOrderHelp: 'Целое число ≥ 0; меньше — выше в списке',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      inactive: 'Архив',
    },
    hints: {
      archivedRow: 'Запись в архиве — будет недоступна в новых заявках',
    },
    modals: {
      createTitle: 'Новая упаковка',
      editTitle: 'Упаковка — {{name}}',
    },
    search: 'Поиск',
    status: {
      active: 'Активна',
      inactive: 'В архиве',
    },
    title: 'Упаковка',
    toasts: {
      activated: 'Упаковка восстановлена',
      archived: 'Упаковка архивирована',
      created: 'Упаковка создана',
      updated: 'Упаковка обновлена',
    },
  },
  russiaCarriers: {
    actions: {
      create: 'Добавить перевозчика',
    },
    columns: {
      contacts: 'Контакты',
      name: 'Название',
      status: 'Статус',
    },
    empty: 'Перевозчики не найдены',
    errors: {
      contactsRequired: 'Контакты обязательны',
      nameRequired: 'Название обязательно',
    },
    fields: {
      contacts: 'Контакты',
      contactsHelp: 'Телефоны, e-mail, мессенджеры — по одному в строке',
      name: 'Название',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      inactive: 'В архиве',
    },
    hints: {
      archivedRow: 'Запись в архиве — недоступна в новых заявках',
    },
    modals: {
      createTitle: 'Новый перевозчик',
      editTitle: 'Перевозчик — {{name}}',
    },
    search: 'Поиск',
    status: {
      active: 'Активен',
      inactive: 'В архиве',
    },
    title: 'Перевозчики РФ',
    toasts: {
      activated: 'Перевозчик восстановлен',
      archived: 'Перевозчик архивирован',
      created: 'Перевозчик создан',
      updated: 'Перевозчик обновлён',
    },
  },
  transportTypes: {
    actions: {
      create: 'Добавить вид транспорта',
    },
    category: {
      container: 'Контейнер',
      truck: 'Тент',
    },
    columns: {
      category: 'Категория',
      code: 'Код',
      name: 'Название',
      payload: 'Грузоподъёмность, т',
      sortOrder: '№',
      status: 'Статус',
      volume: 'Объём, м³',
    },
    empty: 'Виды транспорта не найдены',
    errors: {
      payloadRange: 'Макс. грузоподъёмность должна быть не меньше минимальной',
      volumeRange: 'Макс. объём должен быть не меньше минимального',
    },
    fields: {
      category: 'Категория',
      code: 'Код',
      codeHint: 'Только латиница в нижнем регистре, цифры и _, 2–64 символа. Нельзя изменить.',
      description: 'Описание',
      nameEn: 'Название (EN)',
      nameRu: 'Название (RU)',
      payloadMax: 'Макс. грузоподъёмность, т',
      payloadMin: 'Мин. грузоподъёмность, т',
      sortOrder: 'Порядок сортировки',
      volumeMax: 'Макс. объём, м³',
      volumeMin: 'Мин. объём, м³',
    },
    filters: {
      active: 'Активные',
      all: 'Все',
      categoryAll: 'Все категории',
      inactive: 'Архив',
    },
    modals: {
      createTitle: 'Новый вид транспорта',
      editTitle: 'Вид транспорта — {{name}}',
    },
    range: '{{min}} – {{max}}',
    search: 'Поиск',
    status: {
      active: 'Активен',
      inactive: 'В архиве',
    },
    title: 'Вид транспорта',
    toasts: {
      activated: 'Вид транспорта восстановлен',
      archived: 'Вид транспорта архивирован',
      created: 'Вид транспорта создан',
      updated: 'Вид транспорта обновлён',
    },
  },
  sources: {
    title: 'Источники лидов',
    actions: {
      create: 'Добавить источник',
      rotate: 'Сменить секрет',
      archive: 'В архив',
    },
    columns: {
      code: 'Код',
      displayName: 'Название',
      status: 'Статус',
      secretIssuedAt: 'Секрет выдан',
    },
    status: {
      enabled: 'Включён',
      disabled: 'Отключён',
      archived: 'В архиве',
    },
    filters: {
      active: 'Активные и отключённые',
      all: 'Включая архив',
    },
    empty: {
      title: 'Источников лидов пока нет',
      text: 'Создайте первый источник, чтобы принимать лиды.',
    },
    form: {
      createTitle: 'Новый источник лидов',
      editTitle: 'Редактирование источника',
      code: 'Код',
      codeHelp: 'Строчные ASCII-буквы, цифры, нижние подчёркивания. Изменить нельзя.',
      codePlaceholder: 'website_intake',
      codeShapeError: 'Код должен соответствовать a-z, 0-9, _ (3–64 символа).',
      displayName: 'Название',
      enabled: 'Включён — принимать входящие запросы',
      create: 'Создать',
      save: 'Сохранить',
    },
    confirm: {
      rotate:
        'Смена секрета немедленно инвалидирует старый. Новый секрет будет показан только один раз. Продолжить?',
      archive: 'Архивировать источник? Входящие запросы будут возвращать 410 Gone.',
    },
    reveal: {
      title: 'Секрет источника лидов — показывается один раз',
      warning:
        'Скопируйте секрет сейчас. Он больше не будет показан — восстановить можно только через смену.',
      source: 'Источник',
      secret: 'Секрет',
      copy: 'Копировать',
      copiedShort: 'Скопировано',
      copied: 'Секрет скопирован в буфер обмена.',
      copyFallback:
        'Не удалось скопировать в буфер. Выделите значение секрета и скопируйте вручную перед закрытием.',
      closeWithoutCopy: 'Закрыть без копирования',
    },
    toasts: {
      created: 'Источник создан. Скопируйте секрет до закрытия окна.',
      updated: 'Источник обновлён',
      rotated: 'Секрет обновлён. Скопируйте новый секрет до закрытия окна.',
      archived: 'Источник архивирован',
    },
    logs: {
      title: 'Журнал доставки — {{code}}',
      empty: {
        title: 'Записей нет',
        text: 'Записи появятся, когда источник получит первый запрос.',
      },
      lead: 'лид {{id}}',
      idempotency: 'ключ идемпотентности {{key}}',
    },
  },
  stages: {
    title: 'Этапы лидов',
    hint: {
      lockedCatalog:
        'Семь канонических этапов заблокированы. Редактируются только метки и шаблоны задач.',
    },
    columns: {
      sortOrder: '#',
      code: 'Код',
      kind: 'Тип',
      displayName: 'Метка',
      taskTitle: 'Заголовок задачи',
      defaultDueMinutes: 'Срок по умолчанию (мин)',
      noTaskTitle: 'Без задачи',
    },
    kind: {
      ACTIVE: 'Активный',
      TERMINAL: 'Терминальный',
    },
    empty: {
      title: 'Этапы лидов не заполнены',
      text: 'Запустите миграцию-сидер, чтобы создать семь канонических этапов.',
    },
    form: {
      editTitle: 'Редактирование этапа',
      code: 'Код',
      kind: 'Тип',
      displayName: 'Метка',
      taskTitle: 'Заголовок задачи',
      taskTitleClearHint: 'Оставьте пустым, чтобы не создавать задачу автоматически',
      defaultDueMinutes: 'Срок по умолчанию (минуты)',
      defaultDueClearHint: 'Оставьте пустым, чтобы не задавать срок по умолчанию',
      defaultDueRange: 'Целое число от {{min}} до {{max}}',
      save: 'Сохранить',
    },
    toasts: {
      updated: 'Этап обновлён',
    },
  },
  warehouses: {
    columns: {
      carrier: 'Перевозчик',
      city: 'Город',
      description: 'Описание',
    },
    empty: 'Склады не найдены',
    search: 'Поиск',
    title: 'Склады',
    toasts: {
      copied: 'Описание скопировано',
      copyFailed: 'Не удалось скопировать описание',
    },
  },
  priceLists: {
    columns: {
      carrier: 'Перевозчик',
      name: 'Прайс',
      preview: 'Файл',
    },
    empty: 'Прайсы не найдены',
    fileLabel: {
      file: 'Файл',
      image: 'Фото',
      pdf: 'PDF',
    },
    modalTitle: '{{carrier}} — {{name}}',
    search: 'Поиск',
    title: 'Прайсы',
  },
  audit: {
    actorDeleted: '(удалён)',
    detailTitle: 'Событие: {{action}}',
    empty: 'Нет записей',
    events: {
      arrivalCityArchive: 'Город прибытия архивирован',
      arrivalCityCreate: 'Город прибытия создан',
      arrivalCityRestore: 'Город прибытия восстановлен',
      arrivalCityUpdate: 'Город прибытия обновлён',
      carrierCreate: 'Перевозчик создан',
      carrierActivate: 'Перевозчик активирован',
      carrierDeactivate: 'Перевозчик деактивирован',
      carrierPriceListCreate: 'Прайс перевозчика создан',
      carrierPriceListDelete: 'Прайс перевозчика удалён',
      carrierPriceListUpdate: 'Прайс перевозчика обновлён',
      carrierUpdate: 'Перевозчик обновлён',
      carrierWarehouseCreate: 'Склад перевозчика создан',
      carrierWarehouseDelete: 'Склад перевозчика удалён',
      carrierWarehouseUpdate: 'Склад перевозчика обновлён',
      clientArchive: 'Клиент архивирован',
      clientContactAdd: 'Контакт добавлен',
      clientContactArchive: 'Контакт архивирован',
      clientContactRestore: 'Контакт восстановлен',
      clientContactSetPrimary: 'Основной контакт изменён',
      clientContactUpdate: 'Контакт обновлён',
      clientCreate: 'Клиент создан',
      clientLegalAdd: 'Юр. лицо добавлено',
      clientLegalArchive: 'Юр. лицо архивировано',
      clientLegalRequisitesAdd: 'Реквизиты добавлены',
      clientLegalRequisitesArchive: 'Реквизиты архивированы',
      clientLegalRequisitesRestore: 'Реквизиты восстановлены',
      clientLegalRequisitesUpdate: 'Реквизиты обновлены',
      clientLegalRestore: 'Юр. лицо восстановлено',
      clientLegalUpdate: 'Юр. лицо обновлено',
      clientRestore: 'Клиент восстановлен',
      clientUpdate: 'Клиент обновлён',
      clientVersionRestore: 'Клиент восстановлен из версии',
      departmentArchive: 'Отдел архивирован',
      departmentCreate: 'Отдел создан',
      departmentRestore: 'Отдел восстановлен',
      departmentUpdate: 'Отдел обновлён',
      requestCarrierAdd: 'Перевозчик добавлен к заявке',
      requestBoxRegroup: 'Группы товаров в коробке перераспределены',
      requestCarrierRemove: 'Перевозчик снят с заявки',
      requestCarrierUpdate: 'Ставка перевозчика обновлена',
      requestChat: 'Сообщение в чате заявки',
      requestChatMarkUnread: 'Чат отмечен как непрочитанный',
      requestChatUnmarkUnread: 'Метка «непрочитано» снята',
      requestCreate: 'Заявка создана',
      requestDelete: 'Заявка удалена',
      requestDraftIdempotentResolve: 'Повторный POST черновика заявки разрешён по clientToken',
      requestChildRussiaCreated: 'Создана ставка по РФ из этой заявки',
      requestTransition: 'Переход статуса заявки',
      requestUpdate: 'Заявка обновлена',
      requestWinner: 'Победитель выбран',
      roleArchive: 'Роль архивирована',
      roleCreate: 'Роль создана',
      rolePermissionsSet: 'Права роли изменены',
      roleRestore: 'Роль восстановлена',
      roleUpdate: 'Роль обновлена',
      russiaRequestCreate: 'Заявка по РФ создана',
      russiaRequestDelete: 'Заявка по РФ удалена',
      russiaRequestTransition: 'Статус заявки по РФ изменён',
      russiaRequestUpdate: 'Заявка по РФ обновлена',
      russiaRequestChat: 'Сообщение в чате по заявке РФ',
      russiaRequestChatMarkUnread: 'Чат заявки РФ отмечен как непрочитанный',
      russiaRequestChatUnmarkUnread: 'Снята отметка о непрочитанном в чате РФ',
      cargoCreate: 'Создан груз',
      cargoUpdate: 'Изменён груз',
      cargoDelete: 'Удалён груз',
      cargoImport: 'Импорт грузов',
      cargoDocumentAdd: 'Добавлен платёжный документ груза',
      cargoDocumentDelete: 'Удалён платёжный документ груза',
      cargoPaymentSet: 'Установлен статус оплаты клиентом',
      cargoPaymentQuickSet: 'Быстрая установка оплаты клиентом',
      cargoPaymentRequestStatus: 'Запрошен статус оплаты клиентом',
      cargoPaymentReview: 'Проверка оплаты клиентом',
      cargoProblemCreate: 'Создана проблема груза',
      cargoProblemUpdate: 'Проблема груза изменена',
      cargoProblemTransition: 'Изменён статус проблемы груза',
      cargoProblemDelete: 'Удалён черновик проблемы груза',
      cargoProblemComment: 'Добавлен комментарий к проблеме груза',
      cargoProblemFileUpload: 'Добавлен файл к проблеме груза',
      cargoProblemAssigneeChange: 'Изменён исполнитель проблемы груза',
      cargoProblemAttachmentDelete: 'Удалено вложение проблемы груза',
      cargoProblemReactionEscalate: 'Эскалация срока реакции по проблеме груза',
      cargoClientTariffSet: 'Установлен клиентский тариф груза',
      cargoChinaPaymentSet: 'Установлена оплата в Китае',
      cargoCarrierPaymentSet: 'Установлен статус оплаты перевозчику',
      cargoDictionaryChange: 'Изменён справочник грузов',
      leadIntakeDutyToggle: 'Переключено дежурство по приёму лидов',
      callCenterAgentBind: 'Изменена привязка источника колл-центра',
      clientLifecycleWorking: 'Клиент отмечен как рабочий',
      packagingOptionArchive: 'Упаковка архивирована',
      packagingOptionCreate: 'Упаковка создана',
      packagingOptionRestore: 'Упаковка восстановлена',
      packagingOptionUpdate: 'Упаковка обновлена',
      russiaCarrierArchive: 'Перевозчик РФ архивирован',
      russiaCarrierCreate: 'Перевозчик РФ создан',
      russiaCarrierRestore: 'Перевозчик РФ восстановлен',
      russiaCarrierUpdate: 'Перевозчик РФ обновлён',
      roadOptionArchive: 'Дорога архивирована',
      roadOptionCreate: 'Дорога создана',
      roadOptionRestore: 'Дорога восстановлена',
      roadOptionUpdate: 'Дорога обновлена',
      transportTypeArchive: 'Вид транспорта архивирован',
      transportTypeCreate: 'Вид транспорта создан',
      transportTypeRestore: 'Вид транспорта восстановлен',
      transportTypeUpdate: 'Вид транспорта обновлён',
      userChangePassword: 'Пароль пользователя изменён',
      userCreate: 'Пользователь создан',
      userDeactivate: 'Пользователь деактивирован',
      userReactivate: 'Пользователь восстановлен',
      userResetPassword: 'Пароль пользователя сброшен',
      userSelfUpdate: 'Профиль обновлён пользователем',
      userShiftToggle: 'Логист изменил статус смены',
      userUpdate: 'Пользователь обновлён',
    },
    fields: {
      action: 'Действие',
      actor: 'Актер',
      reason: 'Причина',
      target: 'Цель',
      time: 'Время',
    },
    filters: {
      action: 'Действие',
      actor: 'Актер',
      actorPlaceholder: 'Актер (UUID)',
      all: 'Все',
      allActions: 'Все действия',
      dateFrom: 'С',
      dateFromPlaceholder: 'С (ISO)',
      dateTo: 'По',
      dateToPlaceholder: 'По (ISO)',
      targetId: 'ID цели',
      targetType: 'Тип цели',
    },
    loadMore: 'Показать ещё',
    noDiff: 'Без diff',
    title: 'Журнал аудита',
  },
  departments: {
    actions: {
      create: 'Создать отдел',
      unarchive: 'Разархивировать',
    },
    columns: {
      name: 'Название',
      status: 'Статус',
    },
    confirm: {
      archiveText:
        'Отдел «{{name}}» больше не будет доступен для назначения новым сотрудникам. Существующие сотрудники сохранят свою привязку.',
      archiveTitle: 'Архивировать отдел',
      restoreText: 'Отдел «{{name}}» снова станет доступен для назначения сотрудникам.',
      restoreTitle: 'Разархивировать отдел',
    },
    detail: {
      archivedSuffix: 'архив',
      back: '← Отделы',
      employees: 'Сотрудников: {{total}} (активных: {{active}})',
      emptyEmployees: 'В этом отделе ещё нет сотрудников',
      loadEmployeesError: 'Не удалось загрузить сотрудников',
    },
    empty: 'Отделы ещё не созданы',
    fields: {
      namePlaceholder: 'Название отдела',
    },
    modals: {
      createTitle: 'Новый отдел',
      renameTitle: 'Переименовать отдел',
    },
    title: 'Отделы',
    toasts: {
      archived: 'Отдел архивирован',
      created: 'Отдел создан',
      renamed: 'Отдел переименован',
      restored: 'Отдел восстановлен',
    },
  },
  roles: {
    actions: {
      archiveSystem: 'Архивировать (системная)',
      create: 'Создать роль',
    },
    columns: {
      identifier: 'Идентификатор',
      name: 'Название',
      status: 'Статус',
      type: 'Тип',
    },
    confirm: {
      archiveText:
        'Роль «{{name}}» будет архивирована. Существующие пользователи остаются прикреплены, но новые/изменяемые пользователи не смогут получить эту роль.',
      archiveTitle: 'Архивировать роль',
      restoreText: 'Роль «{{name}}» снова станет доступна для назначения пользователям.',
      restoreTitle: 'Восстановить роль',
    },
    empty: 'Роли ещё не созданы',
    fields: {
      description: 'Описание',
      descriptionOptional: 'Описание (необязательно)',
      displayName: 'Отображаемое имя',
      identifier: 'Идентификатор',
      identifierCreate: 'Идентификатор (lowercase, без точек)',
      displayNamePlaceholder: 'Менеджер продаж',
    },
    modals: {
      createTitle: 'Новая роль',
    },
    tabs: {
      details: 'Сведения',
      permissions: 'Права',
      users: 'Пользователи',
    },
    title: 'Роли',
    toasts: {
      archived: 'Роль архивирована',
      created: 'Роль создана',
      permissionsUpdated: 'Права обновлены',
      restored: 'Роль восстановлена',
      updated: 'Роль обновлена',
    },
    users: {
      empty: 'Ни один пользователь не назначен на эту роль.',
    },
  },
  users: {
    actions: {
      changePassword: 'Сменить пароль',
      create: 'Создать пользователя',
      reset: 'Сбросить',
    },
    confirm: {
      emailChangeConfirm: 'Сменить email',
      emailChangeText: 'Смена email выключит все активные сессии пользователя. Продолжить?',
      emailChangeTitle: 'Подтвердите смену email',
    },
    empty: 'Нет пользователей',
    errors: {
      invalidPhone: 'Введите номер в международном формате, например +79991234567',
    },
    fields: {
      currentPassword: 'Текущий пароль',
      department: 'Отдел',
      name: 'Имя',
      newPassword: 'Новый пароль',
      password: 'Пароль',
      phone: 'Телефон',
      role: 'Роль',
      status: 'Статус',
    },
    filters: {
      active: 'Активные',
      inactive: 'Неактивные',
    },
    modals: {
      changePasswordTitle: 'Смена пароля',
      createTitle: 'Новый пользователь',
      deactivateText: 'Все активные сессии пользователя будут принудительно закрыты.',
      deactivateTitle: 'Деактивировать {{name}}',
      reactivateText: 'Пользователь снова сможет входить в систему.',
      reactivateTitle: 'Реактивировать {{name}}',
      resetPasswordTitle: 'Сбросить пароль {{name}}',
    },
    placeholders: {
      departmentLoading: 'Загрузка отделов…',
      departmentSelect: 'Выберите отдел',
      roleLoading: 'Загрузка ролей…',
      roleSelect: 'Выберите роль',
      deactivationReason: 'Причина деактивации…',
    },
    password: {
      confirmNew: 'Подтвердите новый пароль',
      confirmRequired: 'Подтвердите новый пароль',
      mismatch: 'Пароли не совпадают',
      newMustDiffer: 'Новый пароль должен отличаться от текущего',
      requirement: 'Минимум 12 символов.',
      requirementWithDifference: 'Минимум 12 символов. Должен отличаться от текущего.',
    },
    tabs: {
      actions: 'Действия',
      profile: 'Профиль',
    },
    title: 'Пользователи',
    toasts: {
      changePasswordSuccess: 'Пароль обновлён. Войдите заново.',
      created: 'Пользователь создан',
      deactivated: 'Пользователь деактивирован',
      reactivated: 'Пользователь реактивирован',
      resetPassword: 'Пароль сброшен. Пользователь увидит метку «Требуется смена пароля».',
      saved: 'Изменения сохранены',
    },
  },
  revenue: {
    title: 'Выручка',
    monthSelectLabel: 'Месяц',
    chart: {
      title: 'Накопительная выручка по дням',
      empty: 'Нет данных для построения графика.',
    },
    kpi: {
      total: 'Итого за месяц',
      buyouts: 'Выкуп',
      foreignTrade: 'ВЭД',
      logistics: 'Логистика',
    },
    comparison: {
      previousMonth: 'Сравнение с прошлым месяцем',
      previousYear: 'Сравнение с прошлым годом',
      selectedTotal: 'Текущий период',
      comparisonTotal: 'Период сравнения',
      noData: 'Нет данных за сопоставимый период.',
      sheetMissing: 'Лист для сравнения не найден.',
    },
    manager: {
      name: 'Менеджер',
      total: 'Итого',
      buyouts: 'Выкуп',
      foreignTrade: 'ВЭД',
      logistics: 'Логистика',
    },
    source: {
      label: 'Источник:',
      warning:
        'Внешний сервис Google Sheets. Доступ к таблице открыт по ссылке — содержимое могут увидеть все, у кого есть ссылка.',
    },
    freshness: {
      fetchedAt: 'Обновлено {{time}}',
    },
    stale: {
      banner: 'Показаны данные из кэша',
      generic: 'не удалось обновить данные.',
      upstream_timeout: 'таблица не ответила вовремя.',
      upstream_5xx: 'таблица временно недоступна.',
      upstream_4xx: 'доступ к таблице запрещён.',
      parse_error: 'не удалось разобрать ответ таблицы.',
      network_error: 'сетевая ошибка при обращении к таблице.',
    },
    errors: {
      notConfiguredTitle: 'Источник не настроен',
      notConfiguredText:
        'Переменная окружения REVENUE_GOOGLE_SHEETS_SOURCE не задана. Обратитесь к администратору.',
      sourceInvalidTitle: 'Неверная конфигурация источника',
      sourceInvalidText:
        'Значение REVENUE_GOOGLE_SHEETS_SOURCE не похоже на идентификатор Google Sheets.',
      sourceUnavailableTitle: 'Источник недоступен',
      sourceUnavailableText: 'Не удалось получить данные из Google Sheets. Попробуйте обновить.',
      invalidMonthTitle: 'Неверный месяц',
      invalidMonthText: 'Ожидался месяц в формате YYYY-MM.',
      monthNotFoundTitle: 'Месяц не найден',
      monthNotFoundText: 'Для выбранного месяца лист не найден в источнике.',
    },
  },
  crm: {
    requests: {
      title: 'Заявки',
      empty: 'Нет связанных заявок',
      error: 'Не удалось загрузить заявки',
      slaLabel: 'Срок SLA',
      createAction: 'Создать заявку',
    },
  },
  leads: {
    title: 'Лиды',
    empty: 'Лидов нет',
    actions: {
      create: 'Создать лид',
      loadMore: 'Загрузить ещё',
      claim: 'Взять в работу',
    },
    fields: {
      publicCode: 'Код',
      name: 'Имя',
      phone: 'Телефон',
      email: 'E-mail',
      comment: 'Комментарий',
      title: 'Тема',
      stage: 'Этап',
      manager: 'Менеджер',
      client: 'Клиент',
      status: 'Статус',
      unassigned: 'Не назначен',
      intake: 'Колл-центр',
    },
    filters: {
      search: {
        label: 'Поиск',
        placeholder: 'Тема, имя, телефон или код',
      },
      stage: {
        label: 'Этап',
        allLabel: 'Все этапы',
      },
      source: {
        label: 'Источник',
        allLabel: 'Все источники',
      },
      unassigned: {
        label: 'Назначение',
        all: 'Все лиды',
        only: 'Только нераспределённые',
      },
      archive: {
        label: 'Архив',
        active: 'Активные',
        archived: 'Архивные',
        all: 'Все',
      },
      manager: {
        label: 'Менеджер',
        placeholder: 'Все менеджеры',
      },
    },
    intake: {
      title: 'Заявки колл-центра',
      empty: 'Заявок колл-центра нет',
      audioLink: 'Запись разговора',
      countTitle: 'Заявок из колл-центра',
      source: 'Источник',
      submittedBy: 'Отправитель',
      outcome: {
        CREATED_LEAD: 'Создан лид',
        DUPLICATE_EXISTING_LEAD: 'Дубликат существующего лида',
        REJECTED_VALIDATION: 'Отклонено: проверка данных',
        REJECTED_SOURCE_DISABLED: 'Отклонено: источник отключён',
        REJECTED_NO_PROFILE: 'Отклонено: нет профиля',
        INTERNAL_ERROR: 'Внутренняя ошибка',
      },
    },
    attention: {
      title: 'Требуют внимания',
      resolve: 'Завершить',
      empty: 'Нет задач, требующих внимания',
      callbackUrgent: 'Срочный перезвон',
    },
    stage: {
      new: 'Новый',
      inWork: 'В работе',
      postponed: 'Отложен',
      awaitingPayment: 'Ожидает оплаты',
      returned: 'Возвращён',
      notSuitable: 'Не подошёл',
      refusal: 'Отказ',
      paid: 'Оплачен',
    },
    stageControls: {
      pickTarget: 'Выберите этап',
      apply: 'Перевести',
      paidRequiresClient: 'Чтобы перевести в «Оплачен», сначала привяжите клиента.',
      terminalNote: 'Терминальный этап — переход невозможен.',
      archivedNote: 'Лид в архиве — переходы недоступны.',
    },
    modals: {
      createTitle: 'Новый лид',
    },
    duplicates: {
      title: 'Найдены лиды с этим телефоном',
      body: 'Откройте существующий лид, если это та же сделка.',
      archived: 'в архиве',
      open: 'Открыть',
      createdPrefix: 'Лид создан:',
    },
    phoneExists: {
      title: 'Этот телефон уже используется',
      body: 'Запись с этим телефоном уже существует. Откройте её, чтобы продолжить.',
      bodyWithCode: 'Запись {{code}} уже использует этот телефон. Откройте её, чтобы продолжить.',
      openLead: 'Открыть существующий лид',
      openClient: 'Открыть существующего клиента',
    },
    client: {
      none: 'Клиент не привязан',
      bind: 'Привязать клиента',
      unbind: 'Отвязать',
      openClient: 'Открыть карточку клиента',
      searchPlaceholder: 'Поиск по имени, телефону, ИНН',
      empty: 'Совпадений нет',
    },
    match: {
      title: 'Привязать лид к клиенту',
      confirm: 'Привязать',
      loading: 'Подбираем контакты…',
      loadError: 'Не удалось загрузить контакты',
      targetLabel: 'Контакт клиента',
      contactNameLabel: 'Имя нового контакта',
      contactMatched: '{{name}} (совпадение по контакту)',
      createOption: 'Создать новый контакт',
    },
    admin: {
      title: 'Действия администратора',
      pickManager: 'Выберите менеджера',
      reassign: 'Назначить',
      noAssignableManagers: 'Нет доступных менеджеров',
    },
    errors: {
      invalidPhone: 'Введите номер в международном формате, например +79991234567',
    },
    toasts: {
      created: 'Лид создан',
      stageChanged: 'Этап изменён',
      clientBound: 'Клиент привязан',
      clientUnbound: 'Клиент отвязан',
      claimed: 'Лид взят в работу',
      archived: 'Лид архивирован',
      restored: 'Лид восстановлен',
      reassigned: 'Менеджер изменён',
    },
    activity: {
      feed: {
        title: 'Активность',
        empty: 'Событий пока нет',
        actorSystem: 'Система',
        commentDeleted: '(комментарий удалён)',
        fileDeleted: '(файл удалён)',
      },
      kind: {
        LEAD_CREATED: 'создал(а) лид',
        LEAD_STAGE_CHANGED: 'изменил(а) этап',
        LEAD_ASSIGNED: 'назначил(а) менеджера',
        LEAD_UNASSIGNED: 'снял(а) менеджера',
        LEAD_CLIENT_BOUND: 'привязал(а) клиента',
        LEAD_CLIENT_UNBOUND: 'отвязал(а) клиента',
        LEAD_TASK_CREATED: 'создал(а) задачу',
        LEAD_TASK_COMPLETED: 'завершил(а) задачу',
        LEAD_TASK_CANCELLED: 'отменил(а) задачу',
        LEAD_TASK_REOPENED: 'переоткрыл(а) задачу',
        LEAD_COMMENT_ADDED: 'оставил(а) комментарий',
        LEAD_COMMENT_EDITED: 'отредактировал(а) комментарий',
        LEAD_ARCHIVED: 'архивировал(а) лид',
        LEAD_RESTORED: 'восстановил(а) лид',
        LEAD_REQUEST_LINKED: 'привязал(а) заявку',
        LEAD_REQUEST_UNLINKED: 'отвязал(а) заявку',
        LEAD_FILE_UPLOADED: 'загрузил(а) файл',
        LEAD_FILE_DELETED: 'удалил(а) файл',
        LEAD_INTAKE_RECEIVED: 'получил заявку колл-центра',
        CALL: 'зафиксировал звонок',
        MESSAGE: 'зафиксировал сообщение',
      },
      comments: {
        title: 'Комментарии',
        empty: 'Комментариев нет',
        authorDeleted: '(автор удалён)',
        composerPlaceholder: 'Добавить комментарий…',
        composerAriaLabel: 'Новый комментарий',
        editAriaLabel: 'Редактировать комментарий',
        submit: 'Добавить',
        revisions_one: '{{count}} правка',
        revisions_few: '{{count}} правки',
        revisions_many: '{{count}} правок',
        revisions_other: '{{count}} правок',
        errors: {
          tooLong: 'Текст не должен превышать {{max}} символов',
        },
        toasts: {
          created: 'Комментарий добавлен',
          updated: 'Комментарий обновлён',
        },
      },
      files: {
        title: 'Файлы',
        empty: 'Файлов нет',
        upload: 'Загрузить файл',
        uploading: 'Загружаем…',
        uploaderDeleted: '(автор удалён)',
        usage: 'Использовано {{count}} из {{max}}',
        maxSize: 'Максимум {{size}}',
        capReached: 'Достигнут лимит файлов для этого лида.',
        confirmDelete: {
          title: 'Удалить файл?',
          text: 'Файл «{{name}}» будет удалён. Действие нельзя отменить.',
        },
        errors: {
          tooLarge: 'Файл превышает {{size}}',
          unsupportedMime: 'Этот тип файла не поддерживается',
          nameTooLong: 'Имя файла превышает {{max}} символов',
        },
        toasts: {
          uploaded: 'Файл загружен',
          deleted: 'Файл удалён',
        },
      },
      note: {
        title: 'Заметка',
        placeholder: 'Напишите заметку…',
        submit: 'Сохранить',
        toasts: {
          created: 'Заметка добавлена',
        },
      },
      communications: {
        callTitle: 'Зафиксировать звонок',
        messageTitle: 'Зафиксировать сообщение',
        directionLabel: 'Направление',
        channelLabel: 'Канал',
        occurredAtLabel: 'Дата и время',
        textLabel: 'Комментарий',
        textPlaceholder: 'Что обсудили…',
        transcriptPlaceholder: 'Расшифровка пока недоступна',
        communicationDeleted: '(коммуникация удалена)',
        submit: 'Сохранить',
        direction: {
          INBOUND: 'Входящий',
          OUTBOUND: 'Исходящий',
        },
        channel: {
          PHONE: 'Телефон',
          WHATSAPP: 'WhatsApp',
          TELEGRAM: 'Telegram',
        },
        toasts: {
          created: 'Коммуникация зафиксирована',
        },
      },
    },
    episode: {
      tabs: {
        feed: 'Лента',
        tasks: 'Задачи',
        tasksCount: 'Задачи ({{count}})',
        client: 'О клиенте',
        requests: 'Заявки',
        requestsCount: 'Заявки ({{count}})',
      },
      clientSummary: {
        title: 'Клиент',
      },
      otherEpisodes: {
        title: 'Другие эпизоды клиента',
        leadsTitle: 'Лиды',
        dealsTitle: 'Сделки',
        leadsEmpty: 'Нет других лидов',
        dealsEmpty: 'Нет других сделок',
      },
      capture: {
        note: 'Заметка',
        file: 'Файл',
        call: 'Звонок',
        message: 'Сообщение',
      },
      upcoming: {
        title: 'Запланировано',
        empty: 'Нет запланированных задач',
      },
      filters: {
        toggle: 'Фильтры',
        category: 'Тип',
        searchLabel: 'Поиск',
        searchPlaceholder: 'Поиск по ленте…',
      },
      feedTabs: {
        all: 'Все',
        notes: 'Заметки',
        system: 'Система',
      },
    },
    tasks: {
      title: 'Задачи',
      empty: 'Нет открытых задач',
      openCount_one: '{{count}} открытая',
      openCount_few: '{{count}} открытые',
      openCount_many: '{{count}} открытых',
      openCount_other: '{{count}} открытых',
      overdueCount: '{{count}} просрочено',
      create: 'Новая задача',
      noDue: 'Без срока',
      autoHint: 'Автоматическая задача — управляется системой',
      actions: {
        reschedule: 'Перенести',
        complete: 'Завершить',
        cancel: 'Отменить',
        reopen: 'Вернуть',
      },
      cancelled: {
        title: 'Отменённые',
      },
      form: {
        createTitle: 'Новая задача',
        editTitle: 'Перенос задачи',
        titleLabel: 'Название',
        titlePlaceholder: 'Что нужно сделать?',
        dueLabel: 'Срок',
      },
      toasts: {
        created: 'Задача создана',
        rescheduled: 'Задача обновлена',
        completed: 'Задача завершена',
      },
    },
    buckets: {
      all: 'Все',
      unassigned: 'Нераспределённые',
      new: 'Новые',
      inWork: 'В работе',
      closing: 'Оформление',
      deal: 'Сделки',
      postponed: 'Отложенные',
      noClient: 'Без клиента',
      closed: 'Закрытые',
    },
    list: {
      contact: 'Контакт',
      company: 'Клиент',
      lead: 'Лид',
      noContact: 'Без имени',
      noClientLinked: 'клиент не привязан',
      noCompany: '—',
      tasksColumn: 'Задачи',
      noNextStep: 'Нет следующего шага',
      unqualified: 'Не квалифицирован',
      updated: 'Обновлено',
      totalCount_one: '{{count}} обращение',
      totalCount_few: '{{count}} обращения',
      totalCount_many: '{{count}} обращений',
      totalCount_other: '{{count}} обращений',
      score: 'Оценка',
      overdue: 'Просрочено',
      resumeAt: 'Возврат {{date}}',
      sortLabel: 'Порядок',
      sortRecent: 'Сначала новые',
      sortOldest: 'Сначала старые',
      scoreLabel: 'Оценка',
      scoreAll: 'Любая оценка',
      clientLabel: 'Фильтр по клиенту',
      clientActive: 'Клиент: {{name}}',
      clientClear: 'Сбросить фильтр по клиенту',
      filtersToggle: 'Фильтры',
    },
    card: {
      title: 'Лид',
      funnel: {
        new: 'Новый',
        inWork: 'В работе',
        closing: 'Оформление',
        deal: 'Сделка',
      },
      inWorkLocked: 'Привяжите клиента, чтобы взять в работу',
      actions: {
        postpone: 'Отложить',
        refuse: 'Отказ',
        nonTarget: 'Нецелевой',
        backToWork: 'Вернуть в работу',
      },
      dealCode: 'Сделка',
      score: {
        ariaLabel: 'Оценка {{score}} из 5',
        unrated: 'Без оценки',
        qualifyPrompt: 'Квалифицируйте',
      },
      contact: 'Контакт',
      unnamed: 'Без имени',
      client: {
        title: 'Клиент',
      },
      clientActions: 'Действия с клиентом',
      titleEdit: {
        edit: 'Изменить тему',
        placeholder: 'Тема лида',
        saved: 'Тема обновлена',
      },
      contactActions: {
        call: 'Позвонить',
        email: 'Написать письмо',
        telegram: 'Telegram — нет данных',
        whatsapp: 'WhatsApp — нет данных',
        max: 'MAX — нет данных',
      },
      banner: {
        postponed: 'Отложен · вернётся в работу {{date}}',
        resume: 'Вернуть в работу сейчас',
        terminalRefused: 'Отказ · карточка только для чтения',
        terminalNonTarget: 'Нецелевой · карточка только для чтения',
        deal: 'Сделка {{dealCode}} · оплата подтверждена',
        dealNoCode: 'Сделка · оплата подтверждена',
      },
      artifacts: {
        title: 'Артефакты',
        menuLabel: 'Добавить артефакт',
        addFile: 'Файл',
        addProposal: 'КП',
        system: 'В системе',
        empty: 'Пока пусто. КП и заявки появятся автоматически при создании.',
        kind: {
          request: 'Заявка Китай',
          'russia-request': 'Заявка РФ',
          deal: 'Сделка',
          proposal: 'КП',
        },
      },
    },
    checklist: {
      title: 'Чек-лист оформления',
      progress: '{{done}}/{{total}}',
      optional: 'необязательно',
      confirmPaymentHint: 'Оплата подтверждается сменой этапа на «Оплачен»',
      status: {
        TODO: 'К выполнению',
        DONE: 'Готово',
        SKIPPED: 'Пропущено',
      },
      items: {
        contract_legal_entities_check: 'Проверить юрлица для договора',
        spec: 'Спецификация',
        contract: 'Договор',
        issue_invoice: 'Выставить счёт',
        send_invoice: 'Отправить счёт',
        receive_payment_slip: 'Получить платёжку',
        confirm_payment: 'Подтвердить оплату',
      },
    },
  },
  deals: {
    title: 'Сделки',
    empty: 'Сделок нет',
    wonCount: 'Сделки (выиграно)',
    actions: {
      loadMore: 'Загрузить ещё',
    },
    fields: {
      publicCode: 'Код',
      client: 'Клиент',
      manager: 'Менеджер',
      lead: 'Лид-источник',
      unlinked: 'Не привязан',
      updated: 'Обновлено',
    },
  },
  myDay: {
    title: 'Мой день',
    timezone: 'Часовой пояс: {{tz}}',
    empty: {
      title: 'Задач нет',
      text: 'Задачи появятся здесь, как только будут назначены или подойдут сроки.',
    },
    bucket: {
      overdue: 'Просрочено',
      today: 'Сегодня',
      upcoming: 'Скоро',
      blocked: 'Заблокировано',
    },
    bucketEmpty: {
      overdue: 'Просроченных задач нет.',
      today: 'На сегодня задач нет.',
      upcoming: 'Предстоящих задач нет.',
      blocked: 'Заблокированных задач нет.',
    },
    row: {
      complete: 'Готово',
      completing: 'Сохраняем…',
      stagePrimary: 'Этап',
      callbackUrgent: 'Срочный перезвон',
      openLeadAria: 'Открыть лид {{code}}',
    },
    requests: {
      title: 'Заявки требуют действия',
      loading: 'Загрузка заявок…',
      empty: 'Заявок, требующих действия, нет.',
      error: {
        title: 'Не удалось загрузить заявки',
        text: 'Не удалось загрузить заявки, требующие действия. Попробуйте ещё раз.',
      },
      signal: {
        returned: 'Возвращена',
        slaHot: 'Скоро дедлайн',
        readyToPick: 'Можно выбрать перевозчика',
        unreadChat: 'Непрочитанный чат',
      },
    },
  },
  callCenter: {
    intake: {
      title: 'Новый лид',
      fields: {
        phone: 'Телефон',
        name: 'Имя клиента',
        comment: 'Комментарий',
        audioUrl: 'Ссылка на запись звонка',
      },
      submit: 'Отправить лид',
      success: 'Лид отправлен. Можно вносить следующий.',
      logout: 'Выйти',
      noAccess: {
        title: 'Нет доступа',
        text: 'У вашей учётной записи нет доступа к форме приёма лидов. Обратитесь к администратору.',
      },
      errors: {
        invalidPhone: 'Некорректный номер телефона',
        invalidAudioUrl: 'Некорректная ссылка на запись (нужен адрес https)',
      },
    },
    selfService: {
      title: 'Мои лиды',
      newLead: 'Новый лид',
      searchPlaceholder: 'Поиск по телефону',
      filters: 'Фильтры',
      empty: 'Вы ещё не отправляли ни одного лида.',
      loadMore: 'Показать ещё',
      loading: 'Загрузка…',
      submitSuccess: 'Лид отправлен.',
      ownDuplicate: 'Вы уже отправляли лид с этим номером телефона',
      columns: {
        phone: 'Телефон',
        name: 'Имя клиента',
        comment: 'Комментарий',
        audioUrl: 'Запись звонка',
        createdAt: 'Добавлен',
      },
      audioLink: 'Открыть запись',
      detail: {
        title: 'Лид',
        noComment: 'Без комментария',
        noAudio: 'Нет записи',
      },
      newLeadDrawer: {
        title: 'Новый лид',
      },
    },
  },
  callCenterAdmin: {
    pageTitle: 'Колл-центр и дежурство менеджеров',
    fields: {
      email: 'Email',
      source: 'Источник',
    },
    placeholders: {
      sourceSelect: 'Выберите источник',
    },
    accounts: {
      title: 'Учётные записи колл-центра',
      create: 'Создать учётную запись',
      empty: 'Учётных записей колл-центра пока нет.',
      colName: 'Имя',
      colBinding: 'Источник',
    },
    binding: {
      none: 'Нет привязки',
      warning: 'Требует внимания',
    },
    actions: {
      rebind: 'Сменить источник',
    },
    create: {
      title: 'Новая учётная запись колл-центра',
    },
    rebind: {
      title: 'Сменить привязку источника',
    },
    duty: {
      title: 'Дежурство менеджеров по приёму лидов',
      empty: 'Нет подходящих менеджеров.',
      emptyDutyWarning: 'Ни один менеджер не на дежурстве — новые лиды некому распределять.',
      on: 'На дежурстве',
      off: 'Не на дежурстве',
      ariaOn: 'На дежурстве — нажмите, чтобы снять',
      ariaOff: 'Не на дежурстве — нажмите, чтобы поставить',
    },
    toasts: {
      created: 'Учётная запись создана.',
      rebound: 'Источник изменён.',
    },
  },
  logisticsCalculations: {
    title: 'ТТН',
    loading: 'Загрузка…',
    error: 'Не удалось загрузить расчёты.',
    empty: 'Расчётов пока нет.',
    statuses: { DRAFT: 'Черновик', PUBLISHED: 'Опубликован' },
    delete: {
      title: 'Удалить черновик {{code}}?',
      text: 'Черновик будет удалён навсегда. Его грузы снова можно будет включить в другую ТТН.',
      textRevoked:
        'Этот документ раньше был опубликован и отозван. Он будет удалён навсегда вместе с историей просмотров; его грузы снова можно будет включить в другую ТТН.',
      done: 'Черновик {{code}} удалён',
    },
    paymentLabels: {
      novat: 'Без НДС',
      vatIncluded: 'С НДС',
      individual: 'Физическое лицо',
    },
    payableCurrencies: {
      RUB: 'Рубли',
      USD: 'Доллары',
      USD_RUB: 'Доллары + Рубли',
    },
    sections: {
      chinaLogistics: 'Логистика из Китая',
      chinaExpenses: 'Расходы по Китаю',
      rfExpenses: 'Расходы по РФ',
      rfLogistics: 'Логистика по РФ',
    },
    units: {
      kg: 'кг',
      m3: 'м³',
      package: 'место',
      item: 'шт.',
      cargo: 'груз',
      trip: 'рейс',
      day: 'день',
      fixed: 'фикс.',
      custom: 'Другая',
    },
    list: {
      number: 'Номер',
      status: 'Статус',
      client: 'Клиент',
      owner: 'Менеджер',
      cargos: 'Грузы',
      totalUsd: 'Итого $',
      totalRub: 'Итого ₽',
      views: 'Просмотры',
      updated: 'Обновлён',
    },
    detail: {
      totalUsd: 'Итого USD',
      totalRub: 'Итого RUB',
      htmlViews: 'Просмотры страницы',
    },
    document: {
      narrowNotice:
        'Документ свёрстан по ширине листа A4: заполнять его можно на экране шире. Здесь он открыт только для чтения — таблицы прокручиваются вбок.',
    },
    actions: {
      create: 'Создать ТТН',
      cancel: 'Отмена',
      close: 'Закрыть',
      creating: 'Создание…',
      createDraft: 'Создать черновик',
      save: 'Сохранить',
      edit: 'Редактировать',
      publish: 'Опубликовать',
      revoke: 'Отозвать',
      delete: 'Удалить',
      copyLink: 'Копировать ссылку',
      linkCopied: 'Ссылка скопирована',
      downloadPdf: 'Скачать PDF',
      back: 'К списку',
    },
    editor: {
      title: 'Новый расчёт',
      editTitle: 'Редактирование {{code}}',
      createError: 'Не удалось создать черновик.',
      publishError: 'Не удалось опубликовать документ.',
      publishNotReady: 'Удалите незаполненные услуги, оставшиеся от прежней версии документа.',
      numberAfterSave: 'Номер после сохранения',
      validationError: 'Проверьте обязательные поля и повторите попытку.',
      cargoHeld:
        'Груз уже в расчёте {{code}}. Удалите его строку или освободите груз в том расчёте.',
      cargoHeldUnknown: 'Груз уже в другом расчёте. Удалите его строку из этого документа.',
      prefill: {
        held: 'Груз уже в расчёте {{code}}, поэтому документ открыт без него.',
        unchecked: 'Груз не удалось проверить. Его можно добавить из реестра ниже.',
      },
      fields: {
        style: 'Стиль документа',
        clientCompany: 'Компания',
        clientContactName: 'Контактное лицо',
        clientContactPhone: 'Телефон',
        payDueDate: 'Оплатить до',
        paymentLabel: 'Условия оплаты',
        paymentDivisor: 'Делитель',
        paymentDivisorHint: 'итог / {{divisor}} = к оплате',
        payableCurrency: 'Валюта оплаты',
        rubPerUsdRate: 'Курс $ (₽ за 1 доллар)',
        rubPerCnyRate: 'Курс ¥ (₽ за 1 юань)',
        managerName: 'Имя менеджера',
        managerPhone: 'Телефон менеджера',
        managerTelegram: 'Telegram менеджера',
      },
      cargoPicker: {
        label: 'Добавить груз из реестра',
        placeholder: 'Введите артикул или название',
        choose: 'Выбрать груз',
        add: 'Добавить',
        added: 'Груз {{article}} добавлен.',
        duplicate: 'Груз {{article}} уже добавлен.',
        heldOption: 'в расчёте {{code}}',
        heldMessage: 'Груз уже в расчёте {{code}}. Освободите его там, чтобы добавить сюда.',
      },
      cargo: {
        title: 'Груз {{number}}',
        remove: 'Удалить груз',
        empty: 'Добавьте хотя бы один груз.',
        article: 'Артикул',
        name: 'Наименование',
        seats: 'Места',
        weight: 'Вес',
        volume: 'Объём',
        transportType: 'Транспорт',
        departedAt: 'Отправлен',
        arrivedAt: 'Прибыл',
        invalidDateTime: 'Укажите корректные дату и время.',
      },
      cost: {
        amount: '{{column}}: сумма',
        caption: '{{column}}: пояснение',
        currency: '{{column}}: валюта',
        hints: {
          transport: '250 кг * $4,5 = $1 125',
          insurance: '1% от $2 300',
          extra: 'Описание расхода',
        },
        addExtra: 'Добавить доп. расход',
        removeExtra: 'Удалить доп. расход {{index}}',
        removeLine: 'Удалить услугу',
      },
    },
  },
  logisticsCalculationsPublic: {
    loading: 'Загрузка расчёта…',
    notFound: { title: 'Расчёт не найден', body: 'Ссылка недействительна или больше не доступна.' },
    downloadPdf: 'Скачать PDF',
  },
  validation: {
    required: 'Обязательное поле',
  },
};
